//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_IDENTITY_URL = new InjectionToken<string>('API_IDENTITY_URL');

@Injectable()
export class IdentityClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_IDENTITY_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Authenticates the user.
   * @param body (optional) Query model 'Sign in'.
   * @return Success
   */
  authorization(body: SignInRequest | undefined): Observable<string> {
    let url_ = this.baseUrl + "/api/Authorization";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "application/json"
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAuthorization(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAuthorization(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<string>;
        }
      } else
        return _observableThrow(response_) as any as Observable<string>;
    }));
  }

  protected processAuthorization(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<string>(null as any);
  }

  /**
   * Authenticates the user.
   * @param body (optional) Query model 'Sign In'.
   * @return Success
   */
  createJwt(body: SignInRequest | undefined): Observable<JwtTokenResponse> {
    let url_ = this.baseUrl + "/api/Authorization";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateJwt(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateJwt(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<JwtTokenResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<JwtTokenResponse>;
    }));
  }

  protected processCreateJwt(response: HttpResponseBase): Observable<JwtTokenResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = JwtTokenResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<JwtTokenResponse>(null as any);
  }

  /**
   * Renew Jwt Token the user.
   * @param body (optional) Query model 'Renew token'.
   * @return Success
   */
  renewJwt(body: RenewJwtTokenRequest | undefined): Observable<JwtTokenResponse> {
    let url_ = this.baseUrl + "/api/Authorization/renew";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processRenewJwt(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRenewJwt(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<JwtTokenResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<JwtTokenResponse>;
    }));
  }

  protected processRenewJwt(response: HttpResponseBase): Observable<JwtTokenResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = JwtTokenResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<JwtTokenResponse>(null as any);
  }

  /**
   * Authenticates the user.
   * @param body (optional) Query model 'Sign in'.
   * @return Success
   */
  authorizationWithTwoFa(body: SignInRequest | undefined): Observable<SignInResponse> {
    let url_ = this.baseUrl + "/api/Authorization/login";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAuthorizationWithTwoFa(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAuthorizationWithTwoFa(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SignInResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SignInResponse>;
    }));
  }

  protected processAuthorizationWithTwoFa(response: HttpResponseBase): Observable<SignInResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SignInResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SignInResponse>(null as any);
  }

  /**
   * Authenticates the user with 2fa code
   * @param body (optional) Confirmation request.
   * @return Success
   */
  authorizationConfirmTwoFa(body: TwoFactorConfirmationRequest | undefined): Observable<SignInResponse> {
    let url_ = this.baseUrl + "/api/Authorization/2fa/confirm";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAuthorizationConfirmTwoFa(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAuthorizationConfirmTwoFa(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SignInResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SignInResponse>;
    }));
  }

  protected processAuthorizationConfirmTwoFa(response: HttpResponseBase): Observable<SignInResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SignInResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SignInResponse>(null as any);
  }

  /**
   * Authenticates the user with recovery code
   * @param body (optional) Confirmation request.
   * @return Success
   */
  authorizationConfirmTwoFaRecovery(body: TwoFactorConfirmationRequest | undefined): Observable<SignInResponse> {
    let url_ = this.baseUrl + "/api/Authorization/2fa/recovery";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAuthorizationConfirmTwoFaRecovery(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAuthorizationConfirmTwoFaRecovery(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SignInResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SignInResponse>;
    }));
  }

  protected processAuthorizationConfirmTwoFaRecovery(response: HttpResponseBase): Observable<SignInResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SignInResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SignInResponse>(null as any);
  }

  /**
   * Is authorized info
   * @param body (optional)
   * @return Success
   */
  isAuthorized(body: IsAuthorizedRequest | undefined): Observable<string> {
    let url_ = this.baseUrl + "/api/Authorization/is-authorized";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processIsAuthorized(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processIsAuthorized(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<string>;
        }
      } else
        return _observableThrow(response_) as any as Observable<string>;
    }));
  }

  protected processIsAuthorized(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = ErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<string>(null as any);
  }

  /**
   * OAuth authenticates the user.
   * @param body (optional) Query model 'Oauth'.
   * @return Success
   */
  socialAuthorization(body: OAuthRequest | undefined): Observable<string> {
    let url_ = this.baseUrl + "/api/Authorization/social";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processSocialAuthorization(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSocialAuthorization(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<string>;
        }
      } else
        return _observableThrow(response_) as any as Observable<string>;
    }));
  }

  protected processSocialAuthorization(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = ErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<string>(null as any);
  }

  /**
   * OAuth authenticates the user.
   * @param body (optional) Query model 'Oauth'.
   * @return Success
   */
  socialAuthorizationWithRefreshToken(body: OAuthRequest | undefined): Observable<JwtTokenResponse> {
    let url_ = this.baseUrl + "/api/Authorization/login/social";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processSocialAuthorizationWithRefreshToken(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSocialAuthorizationWithRefreshToken(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<JwtTokenResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<JwtTokenResponse>;
    }));
  }

  protected processSocialAuthorizationWithRefreshToken(response: HttpResponseBase): Observable<JwtTokenResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = JwtTokenResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = ErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<JwtTokenResponse>(null as any);
  }

  /**
   * Checking user registration via telegram
   * @param id (optional)
   * @return Success
   */
  checkTelegram(id: number | undefined): Observable<OAuthTelegramResult> {
    let url_ = this.baseUrl + "/api/Authorization/check-telegram?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCheckTelegram(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCheckTelegram(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OAuthTelegramResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OAuthTelegramResult>;
    }));
  }

  protected processCheckTelegram(response: HttpResponseBase): Observable<OAuthTelegramResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OAuthTelegramResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = ErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OAuthTelegramResult>(null as any);
  }

  /**
   * @return Success
   */
  linkedin(): Observable<void> {
    let url_ = this.baseUrl + "/api/Authorization/linkedin";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processLinkedin(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processLinkedin(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processLinkedin(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param code (optional)
   * @param state (optional)
   * @return Success
   */
  linkedinCallback(code: string | undefined, state: string | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Authorization/linkedin/callback?";
    if (code === null)
      throw new Error("The parameter 'code' cannot be null.");
    else if (code !== undefined)
      url_ += "code=" + encodeURIComponent("" + code) + "&";
    if (state === null)
      throw new Error("The parameter 'state' cannot be null.");
    else if (state !== undefined)
      url_ += "state=" + encodeURIComponent("" + state) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processLinkedinCallback(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processLinkedinCallback(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processLinkedinCallback(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param token (optional)
   * @return Success
   */
  apple(token: string | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Authorization/apple?";
    if (token === null)
      throw new Error("The parameter 'token' cannot be null.");
    else if (token !== undefined)
      url_ += "token=" + encodeURIComponent("" + token) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processApple(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processApple(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processApple(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Callback for Apple sign-in
   * @param body (optional)
   * @return Success
   */
  appleSigninCallback(body: Body | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Authorization/apple-signin";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = Object.keys(body as any).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent((body as any)[key]);
    }).join('&')

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/x-www-form-urlencoded",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAppleSigninCallback(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAppleSigninCallback(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processAppleSigninCallback(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get Contractors
   * @param profileId (optional)
   * @param search (optional)
   * @param contractorSearchType (optional)
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getContractors(profileId: number | undefined, search: string | undefined, contractorSearchType: ContractorSearchType | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<ContractorsResult> {
    let url_ = this.baseUrl + "/api/Contractors?";
    if (profileId === null)
      throw new Error("The parameter 'profileId' cannot be null.");
    else if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (search === null)
      throw new Error("The parameter 'search' cannot be null.");
    else if (search !== undefined)
      url_ += "search=" + encodeURIComponent("" + search) + "&";
    if (contractorSearchType === null)
      throw new Error("The parameter 'contractorSearchType' cannot be null.");
    else if (contractorSearchType !== undefined)
      url_ += "contractorSearchType=" + encodeURIComponent("" + contractorSearchType) + "&";
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetContractors(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetContractors(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ContractorsResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ContractorsResult>;
    }));
  }

  protected processGetContractors(response: HttpResponseBase): Observable<ContractorsResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ContractorsResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ContractorsResult>(null as any);
  }

  /**
   * Add contractors
   * @param body (optional)
   * @return No Content
   */
  addContractor(body: AddContractorRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Contractors";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAddContractor(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddContractor(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processAddContractor(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Exclude contractor
   * @param profileId (optional)
   * @param contractorProfileId (optional)
   * @return No Content
   */
  excludeContractor(profileId: number | undefined, contractorProfileId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Contractors?";
    if (profileId === null)
      throw new Error("The parameter 'profileId' cannot be null.");
    else if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (contractorProfileId === null)
      throw new Error("The parameter 'contractorProfileId' cannot be null.");
    else if (contractorProfileId !== undefined)
      url_ += "contractorProfileId=" + encodeURIComponent("" + contractorProfileId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processExcludeContractor(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processExcludeContractor(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processExcludeContractor(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get participants
   * @param currentProfileId (optional)
   * @param profileIds (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getParticipants(currentProfileId: number | undefined, profileIds: number[] | undefined, pageSize: number | undefined): Observable<ParticipantsResult> {
    let url_ = this.baseUrl + "/api/Contractors/participants?";
    if (currentProfileId === null)
      throw new Error("The parameter 'currentProfileId' cannot be null.");
    else if (currentProfileId !== undefined)
      url_ += "currentProfileId=" + encodeURIComponent("" + currentProfileId) + "&";
    if (profileIds === null)
      throw new Error("The parameter 'profileIds' cannot be null.");
    else if (profileIds !== undefined)
      profileIds && profileIds.forEach(item => { url_ += "profileIds=" + encodeURIComponent("" + item) + "&"; });
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetParticipants(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetParticipants(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ParticipantsResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ParticipantsResult>;
    }));
  }

  protected processGetParticipants(response: HttpResponseBase): Observable<ParticipantsResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ParticipantsResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ParticipantsResult>(null as any);
  }

  /**
   * Get Contractor
   * @param profileId (optional)
   * @param contractorProfileId (optional)
   * @return Success
   */
  getContractor(profileId: number | undefined, contractorProfileId: number | undefined): Observable<ContractorModel> {
    let url_ = this.baseUrl + "/api/Contractors/contractor?";
    if (profileId === null)
      throw new Error("The parameter 'profileId' cannot be null.");
    else if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (contractorProfileId === null)
      throw new Error("The parameter 'contractorProfileId' cannot be null.");
    else if (contractorProfileId !== undefined)
      url_ += "contractorProfileId=" + encodeURIComponent("" + contractorProfileId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetContractor(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetContractor(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ContractorModel>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ContractorModel>;
    }));
  }

  protected processGetContractor(response: HttpResponseBase): Observable<ContractorModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ContractorModel.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ContractorModel>(null as any);
  }

  /**
   * Get Contractor by Id
   * @return Success
   */
  getContractorById(profileId: number): Observable<ContractorModel> {
    let url_ = this.baseUrl + "/api/Contractors/contractor/{profileId}";
    if (profileId === undefined || profileId === null)
      throw new Error("The parameter 'profileId' must be defined.");
    url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetContractorById(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetContractorById(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ContractorModel>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ContractorModel>;
    }));
  }

  protected processGetContractorById(response: HttpResponseBase): Observable<ContractorModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ContractorModel.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ContractorModel>(null as any);
  }

  /**
   * Get Contractor count
   * @param profileId (optional)
   * @param contractorSearchType (optional)
   * @return Success
   */
  getContractorCount(profileId: number | undefined, contractorSearchType: ContractorSearchType | undefined): Observable<number> {
    let url_ = this.baseUrl + "/api/Contractors/contractor-count?";
    if (profileId === null)
      throw new Error("The parameter 'profileId' cannot be null.");
    else if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (contractorSearchType === null)
      throw new Error("The parameter 'contractorSearchType' cannot be null.");
    else if (contractorSearchType !== undefined)
      url_ += "contractorSearchType=" + encodeURIComponent("" + contractorSearchType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetContractorCount(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetContractorCount(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<number>;
        }
      } else
        return _observableThrow(response_) as any as Observable<number>;
    }));
  }

  protected processGetContractorCount(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<number>(null as any);
  }

  /**
   * Get countries dictionary
   * @return Success
   */
  getCountries(): Observable<CountryMultipleQueryResult> {
    let url_ = this.baseUrl + "/api/Dictionaries/countries";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetCountries(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetCountries(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<CountryMultipleQueryResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<CountryMultipleQueryResult>;
    }));
  }

  protected processGetCountries(response: HttpResponseBase): Observable<CountryMultipleQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CountryMultipleQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<CountryMultipleQueryResult>(null as any);
  }

  /**
   * Get CountryDocumentFields dictionary
   * @return Success
   */
  getCountryDocumentFields(): Observable<CountryDocumentFieldMultipleQueryResult> {
    let url_ = this.baseUrl + "/api/Dictionaries/docfields";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetCountryDocumentFields(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetCountryDocumentFields(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<CountryDocumentFieldMultipleQueryResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<CountryDocumentFieldMultipleQueryResult>;
    }));
  }

  protected processGetCountryDocumentFields(response: HttpResponseBase): Observable<CountryDocumentFieldMultipleQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CountryDocumentFieldMultipleQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<CountryDocumentFieldMultipleQueryResult>(null as any);
  }

  /**
   * Change email
   * @param body (optional)
   * @return No Content
   */
  changeEmail(body: ChangeEmailViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Emails/change";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processChangeEmail(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processChangeEmail(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processChangeEmail(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Confirm change email
   * @param body (optional)
   * @return No Content
   */
  confirmChangeEmail(body: ConfirmChangeEmailViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Emails/confirm-change";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processConfirmChangeEmail(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processConfirmChangeEmail(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processConfirmChangeEmail(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Confirm change email v2
   * @param body (optional)
   * @return No Content
   */
  confirmChangeEmailV2(body: ConfirmChangeEmailViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Emails/confirm-change/v2";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processConfirmChangeEmailV2(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processConfirmChangeEmailV2(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processConfirmChangeEmailV2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Send confirmation code
   * @param body (optional)
   * @return No Content
   */
  sendConfirmationCode(body: SendConfirmationCodeViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Emails/send-code";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processSendConfirmationCode(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSendConfirmationCode(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSendConfirmationCode(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Confirm email
   * @param body (optional)
   * @return No Content
   */
  confirmEmailWithCode(body: ConfirmEmailViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Emails/confirm-code";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processConfirmEmailWithCode(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processConfirmEmailWithCode(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processConfirmEmailWithCode(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Resend confirmation code
   * @return No Content
   */
  resendConfirmationCode(): Observable<void> {
    let url_ = this.baseUrl + "/api/Emails/resend-code";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processResendConfirmationCode(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processResendConfirmationCode(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processResendConfirmationCode(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Resend confirmation code v2
   * @return No Content
   */
  resendConfirmationCodeV2(): Observable<void> {
    let url_ = this.baseUrl + "/api/Emails/resend-code/v2";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processResendConfirmationCodeV2(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processResendConfirmationCodeV2(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processResendConfirmationCodeV2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Resend confirmation code
   * @return No Content
   */
  resendConfirmationCode2(email: string): Observable<void> {
    let url_ = this.baseUrl + "/api/Emails/resend-code/{email}";
    if (email === undefined || email === null)
      throw new Error("The parameter 'email' must be defined.");
    url_ = url_.replace("{email}", encodeURIComponent("" + email));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processResendConfirmationCode2(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processResendConfirmationCode2(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processResendConfirmationCode2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get oracles
   * @param profileId (optional)
   * @param search (optional)
   * @param oracleTabType (optional)
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getOracles(profileId: number | undefined, search: string | undefined, oracleTabType: OracleTabType | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<OraclesResult> {
    let url_ = this.baseUrl + "/api/Oracles?";
    if (profileId === null)
      throw new Error("The parameter 'profileId' cannot be null.");
    else if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (search === null)
      throw new Error("The parameter 'search' cannot be null.");
    else if (search !== undefined)
      url_ += "search=" + encodeURIComponent("" + search) + "&";
    if (oracleTabType === null)
      throw new Error("The parameter 'oracleTabType' cannot be null.");
    else if (oracleTabType !== undefined)
      url_ += "oracleTabType=" + encodeURIComponent("" + oracleTabType) + "&";
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetOracles(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOracles(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OraclesResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OraclesResult>;
    }));
  }

  protected processGetOracles(response: HttpResponseBase): Observable<OraclesResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OraclesResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OraclesResult>(null as any);
  }

  /**
   * Add oracle
   * @param body (optional)
   * @return No Content
   */
  addOracle(body: OracleRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Oracles";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAddOracle(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddOracle(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processAddOracle(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Exclude oracle
   * @param profileId (optional)
   * @param oracleProfileId (optional)
   * @return No Content
   */
  excludeOracle(profileId: number | undefined, oracleProfileId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Oracles?";
    if (profileId === null)
      throw new Error("The parameter 'profileId' cannot be null.");
    else if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (oracleProfileId === null)
      throw new Error("The parameter 'oracleProfileId' cannot be null.");
    else if (oracleProfileId !== undefined)
      url_ += "oracleProfileId=" + encodeURIComponent("" + oracleProfileId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processExcludeOracle(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processExcludeOracle(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processExcludeOracle(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get all oracles
   * @param profileId (optional)
   * @return Success
   */
  getAllCurrentOracles(profileId: number | undefined): Observable<OraclesResult> {
    let url_ = this.baseUrl + "/api/Oracles/all-current?";
    if (profileId === null)
      throw new Error("The parameter 'profileId' cannot be null.");
    else if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetAllCurrentOracles(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllCurrentOracles(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OraclesResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OraclesResult>;
    }));
  }

  protected processGetAllCurrentOracles(response: HttpResponseBase): Observable<OraclesResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OraclesResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OraclesResult>(null as any);
  }

  /**
   * Get oracle
   * @param profileId (optional)
   * @param oracleProfileId (optional)
   * @return Success
   */
  getOracle(profileId: number | undefined, oracleProfileId: number | undefined): Observable<OracleModel> {
    let url_ = this.baseUrl + "/api/Oracles/oracle?";
    if (profileId === null)
      throw new Error("The parameter 'profileId' cannot be null.");
    else if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (oracleProfileId === null)
      throw new Error("The parameter 'oracleProfileId' cannot be null.");
    else if (oracleProfileId !== undefined)
      url_ += "oracleProfileId=" + encodeURIComponent("" + oracleProfileId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetOracle(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOracle(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OracleModel>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OracleModel>;
    }));
  }

  protected processGetOracle(response: HttpResponseBase): Observable<OracleModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OracleModel.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OracleModel>(null as any);
  }

  /**
   * Toggle oracle
   * @param body (optional)
   * @return No Content
   */
  toggleOracle(body: ToggleOracleRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Oracles/toggle";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processToggleOracle(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processToggleOracle(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processToggleOracle(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get oracle count
   * @param profileId (optional)
   * @param oracleTabType (optional)
   * @return Success
   */
  getOracleCount(profileId: number | undefined, oracleTabType: OracleTabType | undefined): Observable<number> {
    let url_ = this.baseUrl + "/api/Oracles/oracle-count?";
    if (profileId === null)
      throw new Error("The parameter 'profileId' cannot be null.");
    else if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (oracleTabType === null)
      throw new Error("The parameter 'oracleTabType' cannot be null.");
    else if (oracleTabType !== undefined)
      url_ += "oracleTabType=" + encodeURIComponent("" + oracleTabType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetOracleCount(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOracleCount(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<number>;
        }
      } else
        return _observableThrow(response_) as any as Observable<number>;
    }));
  }

  protected processGetOracleCount(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<number>(null as any);
  }

  /**
   * Get organization agent
   * @param organizationProfileId (optional)
   * @return Success
   */
  getOrganizationAgent(organizationProfileId: number | undefined): Observable<AgentResult> {
    let url_ = this.baseUrl + "/api/OrganizationAgents/organization-agent?";
    if (organizationProfileId === null)
      throw new Error("The parameter 'organizationProfileId' cannot be null.");
    else if (organizationProfileId !== undefined)
      url_ += "organizationProfileId=" + encodeURIComponent("" + organizationProfileId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetOrganizationAgent(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrganizationAgent(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<AgentResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<AgentResult>;
    }));
  }

  protected processGetOrganizationAgent(response: HttpResponseBase): Observable<AgentResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AgentResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<AgentResult>(null as any);
  }

  /**
   * Get organization for agent
   * @param agentProfileId (optional)
   * @return Success
   */
  getOrganizationForAgent(agentProfileId: number | undefined): Observable<OrganizationResult[]> {
    let url_ = this.baseUrl + "/api/OrganizationAgents/organization-for-agent?";
    if (agentProfileId === null)
      throw new Error("The parameter 'agentProfileId' cannot be null.");
    else if (agentProfileId !== undefined)
      url_ += "agentProfileId=" + encodeURIComponent("" + agentProfileId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetOrganizationForAgent(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrganizationForAgent(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrganizationResult[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrganizationResult[]>;
    }));
  }

  protected processGetOrganizationForAgent(response: HttpResponseBase): Observable<OrganizationResult[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrganizationResult.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrganizationResult[]>();
  }

  /**
   * Get organization requests
   * @param profileId (optional)
   * @return Success
   */
  getOrganizationRequests(profileId: number | undefined): Observable<OrganizationResult[]> {
    let url_ = this.baseUrl + "/api/OrganizationAgents/organization-requests?";
    if (profileId === null)
      throw new Error("The parameter 'profileId' cannot be null.");
    else if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetOrganizationRequests(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrganizationRequests(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrganizationResult[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrganizationResult[]>;
    }));
  }

  protected processGetOrganizationRequests(response: HttpResponseBase): Observable<OrganizationResult[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrganizationResult.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrganizationResult[]>();
  }

  /**
   * Add organization agent
   * @param body (optional)
   * @return No Content
   */
  addOrganizationAgent(body: OrganizationAgentViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/OrganizationAgents";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAddOrganizationAgent(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddOrganizationAgent(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processAddOrganizationAgent(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Set organization agent request type
   * @param body (optional)
   * @return No Content
   */
  setOrganizationAgentRequestType(body: SetOrganizationAgentRequestTypeViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/OrganizationAgents/request-type";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processSetOrganizationAgentRequestType(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSetOrganizationAgentRequestType(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSetOrganizationAgentRequestType(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Change user password.
   * @param body (optional) Query model 'Change password'.
   * @return No Content
   */
  changePassword(body: ChangePasswordRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/users/password/current";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processChangePassword(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processChangePassword(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processChangePassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Set user password.
   * @param body (optional) Query model 'Set password'.
   * @return No Content
   */
  setPassword(body: SetPasswordRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/users/password/set";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processSetPassword(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSetPassword(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSetPassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Check user password.
   * @return Success
   */
  checkPassword(): Observable<CheckPasswordResult> {
    let url_ = this.baseUrl + "/api/users/check-password";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCheckPassword(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCheckPassword(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<CheckPasswordResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<CheckPasswordResult>;
    }));
  }

  protected processCheckPassword(response: HttpResponseBase): Observable<CheckPasswordResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CheckPasswordResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = ErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<CheckPasswordResult>(null as any);
  }

  /**
   * Recovery user password.
   * @param body (optional) Model for confirmation.
   * @return No Content
   */
  recoverPassword(body: EmailWithConfirmationActionRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/users/password/recovery";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processRecoverPassword(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRecoverPassword(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processRecoverPassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Confirm recovery user password.
   * @param body (optional) Query model 'Confirm password recovery'.
   * @return No Content
   */
  recoverConfirm(body: ConfirmPasswordRecoveryRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/users/password/recovery/confirm";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processRecoverConfirm(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRecoverConfirm(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processRecoverConfirm(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get the list of user's profiles.
   * @return Success
   */
  getUserProfiles(): Observable<ProfileMultipleQueryResult> {
    let url_ = this.baseUrl + "/api/Profiles";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetUserProfiles(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetUserProfiles(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ProfileMultipleQueryResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ProfileMultipleQueryResult>;
    }));
  }

  protected processGetUserProfiles(response: HttpResponseBase): Observable<ProfileMultipleQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ProfileMultipleQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ProfileMultipleQueryResult>(null as any);
  }

  /**
   * Delete profile
   * @param id (optional)
   * @return No Content
   */
  deleteProfile(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Profiles?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processDeleteProfile(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteProfile(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDeleteProfile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get personal profile by id.
   * @return Success
   */
  getPersonalProfile(profileId: number, isCheckAccessField: boolean): Observable<PersonalProfileResult> {
    let url_ = this.baseUrl + "/api/Profiles/personal/{profileId}/{isCheckAccessField}";
    if (profileId === undefined || profileId === null)
      throw new Error("The parameter 'profileId' must be defined.");
    url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
    if (isCheckAccessField === undefined || isCheckAccessField === null)
      throw new Error("The parameter 'isCheckAccessField' must be defined.");
    url_ = url_.replace("{isCheckAccessField}", encodeURIComponent("" + isCheckAccessField));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetPersonalProfile(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPersonalProfile(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PersonalProfileResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PersonalProfileResult>;
    }));
  }

  protected processGetPersonalProfile(response: HttpResponseBase): Observable<PersonalProfileResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PersonalProfileResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PersonalProfileResult>(null as any);
  }

  /**
   * Get organization profile by id.
   * @return Success
   */
  getOrganizationProfile(profileId: number, isCheckAccessField: boolean): Observable<OrganizationProfileResult> {
    let url_ = this.baseUrl + "/api/Profiles/organization/{profileId}/{isCheckAccessField}";
    if (profileId === undefined || profileId === null)
      throw new Error("The parameter 'profileId' must be defined.");
    url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
    if (isCheckAccessField === undefined || isCheckAccessField === null)
      throw new Error("The parameter 'isCheckAccessField' must be defined.");
    url_ = url_.replace("{isCheckAccessField}", encodeURIComponent("" + isCheckAccessField));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetOrganizationProfile(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrganizationProfile(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrganizationProfileResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrganizationProfileResult>;
    }));
  }

  protected processGetOrganizationProfile(response: HttpResponseBase): Observable<OrganizationProfileResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OrganizationProfileResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrganizationProfileResult>(null as any);
  }

  /**
   * Edit personal profile data
   * @param body (optional) Query model 'Edit personal profile'.
   * @return No Content
   */
  editPersonalProfile(body: EditPersonalProfileViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Profiles/personal";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processEditPersonalProfile(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processEditPersonalProfile(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processEditPersonalProfile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Create personal profile
   * @param body (optional) Query model 'Personal profile'.
   * @return No Content
   */
  createPersonalProfile(body: PersonalProfileViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Profiles/personal";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreatePersonalProfile(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreatePersonalProfile(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreatePersonalProfile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Edit organization profile data
   * @param body (optional) Query model 'Edit organization profile'.
   * @return No Content
   */
  editOrganizationProfile(body: EditOrganizationProfileViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Profiles/organization";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processEditOrganizationProfile(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processEditOrganizationProfile(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processEditOrganizationProfile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Create organization profile
   * @param body (optional) Query model 'Organization profile'.
   * @return No Content
   */
  createOrganizationProfile(body: OrganizationProfileViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Profiles/organization";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateOrganizationProfile(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrganizationProfile(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrganizationProfile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Create new document pattern
   * @param body (optional) Query model 'Profile document pattern'.
   * @return No Content
   */
  createProfileDocumentPattern(body: ProfileDocumentPatternViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Profiles/document-pattern";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateProfileDocumentPattern(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateProfileDocumentPattern(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateProfileDocumentPattern(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Change profile avatar
   * @param body (optional) Query model 'Change profile avatar'.
   * @return No Content
   */
  changeAvatar(body: ChangeProfileAvatarViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Profiles/change-avatar";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processChangeAvatar(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processChangeAvatar(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processChangeAvatar(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get profile by id.
   * @return Success
   */
  getProfileById(profileId: number): Observable<Profile> {
    let url_ = this.baseUrl + "/api/Profiles/profile/{profileId}";
    if (profileId === undefined || profileId === null)
      throw new Error("The parameter 'profileId' must be defined.");
    url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetProfileById(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProfileById(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<Profile>;
        }
      } else
        return _observableThrow(response_) as any as Observable<Profile>;
    }));
  }

  protected processGetProfileById(response: HttpResponseBase): Observable<Profile> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = Profile.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<Profile>(null as any);
  }

  /**
   * Get profiles by telegramId
   * @param telegramIds (optional)
   * @return Success
   */
  getProfilesByTelegramId(telegramIds: string | undefined): Observable<ProfilesByTelegramResult> {
    let url_ = this.baseUrl + "/api/Profiles/profiles-by-telegram?";
    if (telegramIds === null)
      throw new Error("The parameter 'telegramIds' cannot be null.");
    else if (telegramIds !== undefined)
      url_ += "telegramIds=" + encodeURIComponent("" + telegramIds) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetProfilesByTelegramId(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProfilesByTelegramId(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ProfilesByTelegramResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ProfilesByTelegramResult>;
    }));
  }

  protected processGetProfilesByTelegramId(response: HttpResponseBase): Observable<ProfilesByTelegramResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ProfilesByTelegramResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ProfilesByTelegramResult>(null as any);
  }

  /**
   * Change profile email
   * @param body (optional)
   * @return No Content
   */
  changeProfileEmail(body: ChangeProfileEmailViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Profiles/change-email";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processChangeProfileEmail(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processChangeProfileEmail(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processChangeProfileEmail(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Confirm change profile email
   * @param body (optional)
   * @return No Content
   */
  confirmChangeProfileEmail(body: ConfirmChangeProfileEmailViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Profiles/confirm-change-email";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processConfirmChangeProfileEmail(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processConfirmChangeProfileEmail(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processConfirmChangeProfileEmail(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Resend confirmation code
   * @return No Content
   */
  resendConfirmationCodeForChangeProfileEmail(profileId: number): Observable<void> {
    let url_ = this.baseUrl + "/api/Profiles/resend-code/{profileId}";
    if (profileId === undefined || profileId === null)
      throw new Error("The parameter 'profileId' must be defined.");
    url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processResendConfirmationCodeForChangeProfileEmail(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processResendConfirmationCodeForChangeProfileEmail(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processResendConfirmationCodeForChangeProfileEmail(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Delete profile KYC field
   * @param body (optional)
   * @return No Content
   */
  deleteProfileKycField(body: DeleteProfileKycFieldViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Profiles/delete-kyc-field";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processDeleteProfileKycField(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteProfileKycField(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDeleteProfileKycField(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Subscribe to profile
   * @param body (optional) Query model 'Subscribe to profile'.
   * @return No Content
   */
  subscribeToProfile(body: SubscribeViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Profiles/subscribe";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processSubscribeToProfile(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSubscribeToProfile(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSubscribeToProfile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Unsubscribe from profile
   * @param body (optional) Query model 'Subscribe to profile'.
   * @return No Content
   */
  unsubscribeFromProfile(body: SubscribeViewModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Profiles/unsubscribe";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processUnsubscribeFromProfile(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUnsubscribeFromProfile(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUnsubscribeFromProfile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get cryptonomica promocode
   * @return Success
   */
  getCryptonomicaPromoCode(): Observable<CryptonomicaPromoCodeResult> {
    let url_ = this.baseUrl + "/api/ProfileVerification/cryptonomica-promocode";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetCryptonomicaPromoCode(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetCryptonomicaPromoCode(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<CryptonomicaPromoCodeResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<CryptonomicaPromoCodeResult>;
    }));
  }

  protected processGetCryptonomicaPromoCode(response: HttpResponseBase): Observable<CryptonomicaPromoCodeResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CryptonomicaPromoCodeResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<CryptonomicaPromoCodeResult>(null as any);
  }

  /**
   * Get cryptonomica verify profile
   * @param profileId (optional)
   * @param fingerprint (optional)
   * @return Success
   */
  cryptonomicaVerifyProfile(profileId: number | undefined, fingerprint: string | undefined): Observable<CryptonomicaVerificationResult> {
    let url_ = this.baseUrl + "/api/ProfileVerification/cryptonomica-verify?";
    if (profileId === null)
      throw new Error("The parameter 'profileId' cannot be null.");
    else if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (fingerprint === null)
      throw new Error("The parameter 'fingerprint' cannot be null.");
    else if (fingerprint !== undefined)
      url_ += "fingerprint=" + encodeURIComponent("" + fingerprint) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCryptonomicaVerifyProfile(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCryptonomicaVerifyProfile(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<CryptonomicaVerificationResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<CryptonomicaVerificationResult>;
    }));
  }

  protected processCryptonomicaVerifyProfile(response: HttpResponseBase): Observable<CryptonomicaVerificationResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CryptonomicaVerificationResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<CryptonomicaVerificationResult>(null as any);
  }

  /**
   * Save fingerprint
   * @param body (optional)
   * @return No Content
   */
  saveCryptonomicaFingerprint(body: VerifyProfileRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/ProfileVerification/cryptonomica-fingerprint";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processSaveCryptonomicaFingerprint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSaveCryptonomicaFingerprint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSaveCryptonomicaFingerprint(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Creates a new user.
   * @param body (optional) Query model 'Create account'.
   * @return Created
   */
  createUser(body: CreateAccountRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Registration";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateUser(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateUser(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Sends new confirmation token
   * @param body (optional) Model for confirmation.
   * @return No Content
   */
  resendVerification(body: EmailWithConfirmationActionRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Registration";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processResendVerification(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processResendVerification(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processResendVerification(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Confirm user mail.
   * @param body (optional) Query model 'Confirm email'.
   * @return No Content
   */
  confirmEmail(body: ConfirmEmailRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/Registration/email/confirmation";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processConfirmEmail(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processConfirmEmail(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processConfirmEmail(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Sharing information
   * @return Success
   */
  share(encodedString: string): Observable<void> {
    let url_ = this.baseUrl + "/Share/{encodedString}";
    if (encodedString === undefined || encodedString === null)
      throw new Error("The parameter 'encodedString' must be defined.");
    url_ = url_.replace("{encodedString}", encodeURIComponent("" + encodedString));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processShare(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processShare(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processShare(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Returns 2 FA key and qr code
   * @return Success
   */
  getTwoFaKeyAndQrCode(): Observable<TwoFaKeyAndQrCodeResponse> {
    let url_ = this.baseUrl + "/api/TwoFactorAuthentication/GetTwoFaKeyAndQrCode";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTwoFaKeyAndQrCode(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTwoFaKeyAndQrCode(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<TwoFaKeyAndQrCodeResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<TwoFaKeyAndQrCodeResponse>;
    }));
  }

  protected processGetTwoFaKeyAndQrCode(response: HttpResponseBase): Observable<TwoFaKeyAndQrCodeResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TwoFaKeyAndQrCodeResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<TwoFaKeyAndQrCodeResponse>(null as any);
  }

  /**
   * Validate verification code and enable 2FA
   * @param body (optional)
   * @return Success
   */
  enableTwoFa(body: EnableTwoFaAsyncRequest | undefined): Observable<EnableTwoFaResponse> {
    let url_ = this.baseUrl + "/api/TwoFactorAuthentication/EnableTwoFa";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "application/json"
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processEnableTwoFa(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processEnableTwoFa(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<EnableTwoFaResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<EnableTwoFaResponse>;
    }));
  }

  protected processEnableTwoFa(response: HttpResponseBase): Observable<EnableTwoFaResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = EnableTwoFaResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<EnableTwoFaResponse>(null as any);
  }

  /**
   * Disable 2FA
   * @param body (optional) Password
   * @return Success
   */
  disableTwoFa(body: string | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/TwoFactorAuthentication/DisableTwoFa";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processDisableTwoFa(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDisableTwoFa(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDisableTwoFa(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Disable 2FA reminder
   * @return Success
   */
  disableTwoFaReminder(): Observable<void> {
    let url_ = this.baseUrl + "/api/TwoFactorAuthentication/DisableTwoFaReminder";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processDisableTwoFaReminder(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDisableTwoFaReminder(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDisableTwoFaReminder(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Returns recovery codes
   * @param body (optional) Password
   * @return Success
   */
  generateRecoveryCodes(body: string | undefined): Observable<string[]> {
    let url_ = this.baseUrl + "/api/TwoFactorAuthentication/GenerateRecoveryCodes";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGenerateRecoveryCodes(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGenerateRecoveryCodes(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<string[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<string[]>;
    }));
  }

  protected processGenerateRecoveryCodes(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(item);
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<string[]>();
  }

  /**
   * Get current user data
   * @return Success
   */
  getCurrentUser(): Observable<UserResponse> {
    let url_ = this.baseUrl + "/api/users/current";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetCurrentUser(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetCurrentUser(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<UserResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<UserResponse>;
    }));
  }

  protected processGetCurrentUser(response: HttpResponseBase): Observable<UserResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UserResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<UserResponse>(null as any);
  }
}

export enum AccountType {
  Personal = "Personal",
  Organization = "Organization",
  SilentNotary = "SilentNotary",
}

export class AddContractorRequest implements IAddContractorRequest {
  profileId?: number;
  contractorProfileId?: number;

  constructor(data?: IAddContractorRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.contractorProfileId = _data["contractorProfileId"];
    }
  }

  static fromJS(data: any): AddContractorRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AddContractorRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["contractorProfileId"] = this.contractorProfileId;
    return data;
  }
}

export interface IAddContractorRequest {
  profileId?: number;
  contractorProfileId?: number;
}

export class AgentResult implements IAgentResult {
  requestType?: OrganizationRequestType;
  id?: number;
  avatarUrl?: string | undefined;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;
  description?: string | undefined;
  userId?: string;
  fingerprint?: string | undefined;

  constructor(data?: IAgentResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.requestType = _data["requestType"];
      this.id = _data["id"];
      this.avatarUrl = _data["avatarUrl"];
      this.name = _data["name"];
      this.fullName = _data["fullName"];
      this.phoneNumber = _data["phoneNumber"];
      this.isDisplayPhoneNumber = _data["isDisplayPhoneNumber"];
      this.email = _data["email"];
      this.isDisplayEmail = _data["isDisplayEmail"];
      this.isOracle = _data["isOracle"];
      this.description = _data["description"];
      this.userId = _data["userId"];
      this.fingerprint = _data["fingerprint"];
    }
  }

  static fromJS(data: any): AgentResult {
    data = typeof data === 'object' ? data : {};
    let result = new AgentResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["requestType"] = this.requestType;
    data["id"] = this.id;
    data["avatarUrl"] = this.avatarUrl;
    data["name"] = this.name;
    data["fullName"] = this.fullName;
    data["phoneNumber"] = this.phoneNumber;
    data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
    data["email"] = this.email;
    data["isDisplayEmail"] = this.isDisplayEmail;
    data["isOracle"] = this.isOracle;
    data["description"] = this.description;
    data["userId"] = this.userId;
    data["fingerprint"] = this.fingerprint;
    return data;
  }
}

export interface IAgentResult {
  requestType?: OrganizationRequestType;
  id?: number;
  avatarUrl?: string | undefined;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;
  description?: string | undefined;
  userId?: string;
  fingerprint?: string | undefined;
}

export class ChangeEmailViewModel implements IChangeEmailViewModel {
  email?: string | undefined;
  lostOldEmail?: boolean | undefined;

  constructor(data?: IChangeEmailViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
      this.lostOldEmail = _data["lostOldEmail"];
    }
  }

  static fromJS(data: any): ChangeEmailViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ChangeEmailViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["email"] = this.email;
    data["lostOldEmail"] = this.lostOldEmail;
    return data;
  }
}

export interface IChangeEmailViewModel {
  email?: string | undefined;
  lostOldEmail?: boolean | undefined;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
  currentPassword?: string | undefined;
  newPassword?: string | undefined;
  confirmNewPassword?: string | undefined;

  constructor(data?: IChangePasswordRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentPassword = _data["currentPassword"];
      this.newPassword = _data["newPassword"];
      this.confirmNewPassword = _data["confirmNewPassword"];
    }
  }

  static fromJS(data: any): ChangePasswordRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ChangePasswordRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["currentPassword"] = this.currentPassword;
    data["newPassword"] = this.newPassword;
    data["confirmNewPassword"] = this.confirmNewPassword;
    return data;
  }
}

export interface IChangePasswordRequest {
  currentPassword?: string | undefined;
  newPassword?: string | undefined;
  confirmNewPassword?: string | undefined;
}

/** Query model 'Change profile avatar'. */
export class ChangeProfileAvatarViewModel implements IChangeProfileAvatarViewModel {
  profileId?: number;
  avatarUrl?: string | undefined;

  constructor(data?: IChangeProfileAvatarViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.avatarUrl = _data["avatarUrl"];
    }
  }

  static fromJS(data: any): ChangeProfileAvatarViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ChangeProfileAvatarViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["avatarUrl"] = this.avatarUrl;
    return data;
  }
}

/** Query model 'Change profile avatar'. */
export interface IChangeProfileAvatarViewModel {
  profileId?: number;
  avatarUrl?: string | undefined;
}

export class ChangeProfileEmailViewModel implements IChangeProfileEmailViewModel {
  profileId?: number;
  isNewProfile?: boolean;
  email?: string | undefined;
  lostOldEmail?: boolean | undefined;

  constructor(data?: IChangeProfileEmailViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.isNewProfile = _data["isNewProfile"];
      this.email = _data["email"];
      this.lostOldEmail = _data["lostOldEmail"];
    }
  }

  static fromJS(data: any): ChangeProfileEmailViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ChangeProfileEmailViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["isNewProfile"] = this.isNewProfile;
    data["email"] = this.email;
    data["lostOldEmail"] = this.lostOldEmail;
    return data;
  }
}

export interface IChangeProfileEmailViewModel {
  profileId?: number;
  isNewProfile?: boolean;
  email?: string | undefined;
  lostOldEmail?: boolean | undefined;
}

export class CheckPasswordResult implements ICheckPasswordResult {
  isExist?: boolean;

  constructor(data?: ICheckPasswordResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isExist = _data["isExist"];
    }
  }

  static fromJS(data: any): CheckPasswordResult {
    data = typeof data === 'object' ? data : {};
    let result = new CheckPasswordResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isExist"] = this.isExist;
    return data;
  }
}

export interface ICheckPasswordResult {
  isExist?: boolean;
}

export class ConfirmChangeEmailViewModel implements IConfirmChangeEmailViewModel {
  confirmationCode?: string | undefined;
  confirmationCodeNew?: string | undefined;

  constructor(data?: IConfirmChangeEmailViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.confirmationCode = _data["confirmationCode"];
      this.confirmationCodeNew = _data["confirmationCodeNew"];
    }
  }

  static fromJS(data: any): ConfirmChangeEmailViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ConfirmChangeEmailViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["confirmationCode"] = this.confirmationCode;
    data["confirmationCodeNew"] = this.confirmationCodeNew;
    return data;
  }
}

export interface IConfirmChangeEmailViewModel {
  confirmationCode?: string | undefined;
  confirmationCodeNew?: string | undefined;
}

export class ConfirmChangeProfileEmailViewModel implements IConfirmChangeProfileEmailViewModel {
  profileId?: number;
  isNewProfile?: boolean;
  confirmationCode?: string | undefined;
  confirmationCodeNew?: string | undefined;

  constructor(data?: IConfirmChangeProfileEmailViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.isNewProfile = _data["isNewProfile"];
      this.confirmationCode = _data["confirmationCode"];
      this.confirmationCodeNew = _data["confirmationCodeNew"];
    }
  }

  static fromJS(data: any): ConfirmChangeProfileEmailViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ConfirmChangeProfileEmailViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["isNewProfile"] = this.isNewProfile;
    data["confirmationCode"] = this.confirmationCode;
    data["confirmationCodeNew"] = this.confirmationCodeNew;
    return data;
  }
}

export interface IConfirmChangeProfileEmailViewModel {
  profileId?: number;
  isNewProfile?: boolean;
  confirmationCode?: string | undefined;
  confirmationCodeNew?: string | undefined;
}

export class ConfirmEmailRequest implements IConfirmEmailRequest {
  email?: string | undefined;
  confirmationToken?: string | undefined;

  constructor(data?: IConfirmEmailRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
      this.confirmationToken = _data["confirmationToken"];
    }
  }

  static fromJS(data: any): ConfirmEmailRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ConfirmEmailRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["email"] = this.email;
    data["confirmationToken"] = this.confirmationToken;
    return data;
  }
}

export interface IConfirmEmailRequest {
  email?: string | undefined;
  confirmationToken?: string | undefined;
}

export class ConfirmEmailViewModel implements IConfirmEmailViewModel {
  confirmationCode?: string | undefined;
  email?: string | undefined;

  constructor(data?: IConfirmEmailViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.confirmationCode = _data["confirmationCode"];
      this.email = _data["email"];
    }
  }

  static fromJS(data: any): ConfirmEmailViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ConfirmEmailViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["confirmationCode"] = this.confirmationCode;
    data["email"] = this.email;
    return data;
  }
}

export interface IConfirmEmailViewModel {
  confirmationCode?: string | undefined;
  email?: string | undefined;
}

export class ConfirmPasswordRecoveryRequest implements IConfirmPasswordRecoveryRequest {
  email?: string | undefined;
  token?: string | undefined;
  newPassword?: string | undefined;
  confirmNewPassword?: string | undefined;

  constructor(data?: IConfirmPasswordRecoveryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
      this.token = _data["token"];
      this.newPassword = _data["newPassword"];
      this.confirmNewPassword = _data["confirmNewPassword"];
    }
  }

  static fromJS(data: any): ConfirmPasswordRecoveryRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ConfirmPasswordRecoveryRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["email"] = this.email;
    data["token"] = this.token;
    data["newPassword"] = this.newPassword;
    data["confirmNewPassword"] = this.confirmNewPassword;
    return data;
  }
}

export interface IConfirmPasswordRecoveryRequest {
  email?: string | undefined;
  token?: string | undefined;
  newPassword?: string | undefined;
  confirmNewPassword?: string | undefined;
}

export class ContractorModel implements IContractorModel {
  fullName?: string | undefined;
  description?: string | undefined;
  contractorProfileId?: number;
  isAdded?: boolean;
  isOracle?: boolean;
  avatarUrl?: string | undefined;
  profileType?: AccountType;

  constructor(data?: IContractorModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fullName = _data["fullName"];
      this.description = _data["description"];
      this.contractorProfileId = _data["contractorProfileId"];
      this.isAdded = _data["isAdded"];
      this.isOracle = _data["isOracle"];
      this.avatarUrl = _data["avatarUrl"];
      this.profileType = _data["profileType"];
    }
  }

  static fromJS(data: any): ContractorModel {
    data = typeof data === 'object' ? data : {};
    let result = new ContractorModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fullName"] = this.fullName;
    data["description"] = this.description;
    data["contractorProfileId"] = this.contractorProfileId;
    data["isAdded"] = this.isAdded;
    data["isOracle"] = this.isOracle;
    data["avatarUrl"] = this.avatarUrl;
    data["profileType"] = this.profileType;
    return data;
  }
}

export interface IContractorModel {
  fullName?: string | undefined;
  description?: string | undefined;
  contractorProfileId?: number;
  isAdded?: boolean;
  isOracle?: boolean;
  avatarUrl?: string | undefined;
  profileType?: AccountType;
}

export enum ContractorSearchType {
  All = "All",
  CurrentProfile = "CurrentProfile",
}

export class ContractorsResult implements IContractorsResult {
  contractors?: ContractorModel[] | undefined;
  totalCount?: number;

  constructor(data?: IContractorsResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["contractors"])) {
        this.contractors = [] as any;
        for (let item of _data["contractors"])
          this.contractors!.push(ContractorModel.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): ContractorsResult {
    data = typeof data === 'object' ? data : {};
    let result = new ContractorsResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.contractors)) {
      data["contractors"] = [];
      for (let item of this.contractors)
        data["contractors"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }
}

export interface IContractorsResult {
  contractors?: ContractorModel[] | undefined;
  totalCount?: number;
}

export class Country implements ICountry {
  name?: string | undefined;
  alpha3Code?: string | undefined;
  alpha2Code?: string | undefined;
  profiles?: PersonalProfile[] | undefined;
  countryDocumentFields?: CountryDocumentField[] | undefined;
  profileDocuments?: ProfileDocument[] | undefined;
  id?: number;

  constructor(data?: ICountry) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.alpha3Code = _data["alpha3Code"];
      this.alpha2Code = _data["alpha2Code"];
      if (Array.isArray(_data["profiles"])) {
        this.profiles = [] as any;
        for (let item of _data["profiles"])
          this.profiles!.push(PersonalProfile.fromJS(item));
      }
      if (Array.isArray(_data["countryDocumentFields"])) {
        this.countryDocumentFields = [] as any;
        for (let item of _data["countryDocumentFields"])
          this.countryDocumentFields!.push(CountryDocumentField.fromJS(item));
      }
      if (Array.isArray(_data["profileDocuments"])) {
        this.profileDocuments = [] as any;
        for (let item of _data["profileDocuments"])
          this.profileDocuments!.push(ProfileDocument.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Country {
    data = typeof data === 'object' ? data : {};
    let result = new Country();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["alpha3Code"] = this.alpha3Code;
    data["alpha2Code"] = this.alpha2Code;
    if (Array.isArray(this.profiles)) {
      data["profiles"] = [];
      for (let item of this.profiles)
        data["profiles"].push(item.toJSON());
    }
    if (Array.isArray(this.countryDocumentFields)) {
      data["countryDocumentFields"] = [];
      for (let item of this.countryDocumentFields)
        data["countryDocumentFields"].push(item.toJSON());
    }
    if (Array.isArray(this.profileDocuments)) {
      data["profileDocuments"] = [];
      for (let item of this.profileDocuments)
        data["profileDocuments"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }
}

export interface ICountry {
  name?: string | undefined;
  alpha3Code?: string | undefined;
  alpha2Code?: string | undefined;
  profiles?: PersonalProfile[] | undefined;
  countryDocumentFields?: CountryDocumentField[] | undefined;
  profileDocuments?: ProfileDocument[] | undefined;
  id?: number;
}

export class CountryDocumentField implements ICountryDocumentField {
  countryId?: number | undefined;
  documentType?: DocumentType;
  controlName?: string | undefined;
  mask?: string | undefined;
  show?: boolean | undefined;
  country?: Country;
  id?: number;

  constructor(data?: ICountryDocumentField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.countryId = _data["countryId"];
      this.documentType = _data["documentType"];
      this.controlName = _data["controlName"];
      this.mask = _data["mask"];
      this.show = _data["show"];
      this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CountryDocumentField {
    data = typeof data === 'object' ? data : {};
    let result = new CountryDocumentField();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["countryId"] = this.countryId;
    data["documentType"] = this.documentType;
    data["controlName"] = this.controlName;
    data["mask"] = this.mask;
    data["show"] = this.show;
    data["country"] = this.country ? this.country.toJSON() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface ICountryDocumentField {
  countryId?: number | undefined;
  documentType?: DocumentType;
  controlName?: string | undefined;
  mask?: string | undefined;
  show?: boolean | undefined;
  country?: Country;
  id?: number;
}

export class CountryDocumentFieldMultipleQueryResult implements ICountryDocumentFieldMultipleQueryResult {
  count?: number;
  data?: CountryDocumentField[] | undefined;

  constructor(data?: ICountryDocumentFieldMultipleQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data["count"];
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(CountryDocumentField.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CountryDocumentFieldMultipleQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new CountryDocumentFieldMultipleQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["count"] = this.count;
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data)
        data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICountryDocumentFieldMultipleQueryResult {
  count?: number;
  data?: CountryDocumentField[] | undefined;
}

export class CountryMultipleQueryResult implements ICountryMultipleQueryResult {
  count?: number;
  data?: Country[] | undefined;

  constructor(data?: ICountryMultipleQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data["count"];
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(Country.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CountryMultipleQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new CountryMultipleQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["count"] = this.count;
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data)
        data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICountryMultipleQueryResult {
  count?: number;
  data?: Country[] | undefined;
}

export class CreateAccountRequest implements ICreateAccountRequest {
  password?: string | undefined;
  confirmPassword?: string | undefined;
  email?: string | undefined;
  accountType?: AccountType;
  confirmationAction?: string | undefined;

  constructor(data?: ICreateAccountRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.password = _data["password"];
      this.confirmPassword = _data["confirmPassword"];
      this.email = _data["email"];
      this.accountType = _data["accountType"];
      this.confirmationAction = _data["confirmationAction"];
    }
  }

  static fromJS(data: any): CreateAccountRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateAccountRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["password"] = this.password;
    data["confirmPassword"] = this.confirmPassword;
    data["email"] = this.email;
    data["accountType"] = this.accountType;
    data["confirmationAction"] = this.confirmationAction;
    return data;
  }
}

export interface ICreateAccountRequest {
  password?: string | undefined;
  confirmPassword?: string | undefined;
  email?: string | undefined;
  accountType?: AccountType;
  confirmationAction?: string | undefined;
}

export class CryptonomicaPromoCodeResult implements ICryptonomicaPromoCodeResult {
  promoCode?: string | undefined;
  discountInPercent?: number;

  constructor(data?: ICryptonomicaPromoCodeResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.promoCode = _data["promoCode"];
      this.discountInPercent = _data["discountInPercent"];
    }
  }

  static fromJS(data: any): CryptonomicaPromoCodeResult {
    data = typeof data === 'object' ? data : {};
    let result = new CryptonomicaPromoCodeResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["promoCode"] = this.promoCode;
    data["discountInPercent"] = this.discountInPercent;
    return data;
  }
}

export interface ICryptonomicaPromoCodeResult {
  promoCode?: string | undefined;
  discountInPercent?: number;
}

export class CryptonomicaVerificationResult implements ICryptonomicaVerificationResult {
  isVerified?: boolean;

  constructor(data?: ICryptonomicaVerificationResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isVerified = _data["isVerified"];
    }
  }

  static fromJS(data: any): CryptonomicaVerificationResult {
    data = typeof data === 'object' ? data : {};
    let result = new CryptonomicaVerificationResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isVerified"] = this.isVerified;
    return data;
  }
}

export interface ICryptonomicaVerificationResult {
  isVerified?: boolean;
}

/** Query model 'Delete profile KYC field'. */
export class DeleteProfileKycFieldViewModel implements IDeleteProfileKycFieldViewModel {
  profileId?: number;
  type?: KycFieldType;

  constructor(data?: IDeleteProfileKycFieldViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.type = _data["type"];
    }
  }

  static fromJS(data: any): DeleteProfileKycFieldViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new DeleteProfileKycFieldViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["type"] = this.type;
    return data;
  }
}

/** Query model 'Delete profile KYC field'. */
export interface IDeleteProfileKycFieldViewModel {
  profileId?: number;
  type?: KycFieldType;
}

export enum DocumentType {
  NotSelected = "NotSelected",
  Passport = "Passport",
  DriverLicense = "DriverLicense",
  NationalId = "NationalId",
}

/** Query model 'Edit organization profile'. */
export class EditOrganizationProfileViewModel implements IEditOrganizationProfileViewModel {
  id?: number;
  typeOrganization?: string | undefined;
  tin?: string | undefined;
  phoneCompany?: string | undefined;
  registrationAddress?: string | undefined;
  psrn?: string | undefined;
  license?: string | undefined;
  isDisplayTypeOrganization?: boolean;
  isDisplayTin?: boolean;
  isDisplayPhoneCompany?: boolean;
  isDisplayRegistrationAddress?: boolean;
  isDisplayPsrn?: boolean;
  isDisplayLicense?: boolean;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  description?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;

  constructor(data?: IEditOrganizationProfileViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.typeOrganization = _data["typeOrganization"];
      this.tin = _data["tin"];
      this.phoneCompany = _data["phoneCompany"];
      this.registrationAddress = _data["registrationAddress"];
      this.psrn = _data["psrn"];
      this.license = _data["license"];
      this.isDisplayTypeOrganization = _data["isDisplayTypeOrganization"];
      this.isDisplayTin = _data["isDisplayTin"];
      this.isDisplayPhoneCompany = _data["isDisplayPhoneCompany"];
      this.isDisplayRegistrationAddress = _data["isDisplayRegistrationAddress"];
      this.isDisplayPsrn = _data["isDisplayPsrn"];
      this.isDisplayLicense = _data["isDisplayLicense"];
      this.name = _data["name"];
      this.fullName = _data["fullName"];
      this.phoneNumber = _data["phoneNumber"];
      this.description = _data["description"];
      this.isDisplayPhoneNumber = _data["isDisplayPhoneNumber"];
      this.email = _data["email"];
      this.isDisplayEmail = _data["isDisplayEmail"];
      this.isOracle = _data["isOracle"];
    }
  }

  static fromJS(data: any): EditOrganizationProfileViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new EditOrganizationProfileViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["typeOrganization"] = this.typeOrganization;
    data["tin"] = this.tin;
    data["phoneCompany"] = this.phoneCompany;
    data["registrationAddress"] = this.registrationAddress;
    data["psrn"] = this.psrn;
    data["license"] = this.license;
    data["isDisplayTypeOrganization"] = this.isDisplayTypeOrganization;
    data["isDisplayTin"] = this.isDisplayTin;
    data["isDisplayPhoneCompany"] = this.isDisplayPhoneCompany;
    data["isDisplayRegistrationAddress"] = this.isDisplayRegistrationAddress;
    data["isDisplayPsrn"] = this.isDisplayPsrn;
    data["isDisplayLicense"] = this.isDisplayLicense;
    data["name"] = this.name;
    data["fullName"] = this.fullName;
    data["phoneNumber"] = this.phoneNumber;
    data["description"] = this.description;
    data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
    data["email"] = this.email;
    data["isDisplayEmail"] = this.isDisplayEmail;
    data["isOracle"] = this.isOracle;
    return data;
  }
}

/** Query model 'Edit organization profile'. */
export interface IEditOrganizationProfileViewModel {
  id?: number;
  typeOrganization?: string | undefined;
  tin?: string | undefined;
  phoneCompany?: string | undefined;
  registrationAddress?: string | undefined;
  psrn?: string | undefined;
  license?: string | undefined;
  isDisplayTypeOrganization?: boolean;
  isDisplayTin?: boolean;
  isDisplayPhoneCompany?: boolean;
  isDisplayRegistrationAddress?: boolean;
  isDisplayPsrn?: boolean;
  isDisplayLicense?: boolean;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  description?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;
}

/** Query model 'Edit personal profile'. */
export class EditPersonalProfileViewModel implements IEditPersonalProfileViewModel {
  id?: number;
  countryId?: number | undefined;
  birthDate?: Date | undefined;
  city?: string | undefined;
  address?: string | undefined;
  postalCode?: number | undefined;
  province?: string | undefined;
  telegram?: string | undefined;
  skype?: string | undefined;
  isDisplayCountryId?: boolean;
  isDisplayBirthDate?: boolean;
  isDisplayTelegram?: boolean;
  isDisplaySkype?: boolean;
  isDisplayCity?: boolean;
  isDisplayAddress?: boolean;
  documents?: ProfileDocumentViewModel[] | undefined;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  description?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;

  constructor(data?: IEditPersonalProfileViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.countryId = _data["countryId"];
      this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
      this.city = _data["city"];
      this.address = _data["address"];
      this.postalCode = _data["postalCode"];
      this.province = _data["province"];
      this.telegram = _data["telegram"];
      this.skype = _data["skype"];
      this.isDisplayCountryId = _data["isDisplayCountryId"];
      this.isDisplayBirthDate = _data["isDisplayBirthDate"];
      this.isDisplayTelegram = _data["isDisplayTelegram"];
      this.isDisplaySkype = _data["isDisplaySkype"];
      this.isDisplayCity = _data["isDisplayCity"];
      this.isDisplayAddress = _data["isDisplayAddress"];
      if (Array.isArray(_data["documents"])) {
        this.documents = [] as any;
        for (let item of _data["documents"])
          this.documents!.push(ProfileDocumentViewModel.fromJS(item));
      }
      this.name = _data["name"];
      this.fullName = _data["fullName"];
      this.phoneNumber = _data["phoneNumber"];
      this.description = _data["description"];
      this.isDisplayPhoneNumber = _data["isDisplayPhoneNumber"];
      this.email = _data["email"];
      this.isDisplayEmail = _data["isDisplayEmail"];
      this.isOracle = _data["isOracle"];
    }
  }

  static fromJS(data: any): EditPersonalProfileViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new EditPersonalProfileViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["countryId"] = this.countryId;
    data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
    data["city"] = this.city;
    data["address"] = this.address;
    data["postalCode"] = this.postalCode;
    data["province"] = this.province;
    data["telegram"] = this.telegram;
    data["skype"] = this.skype;
    data["isDisplayCountryId"] = this.isDisplayCountryId;
    data["isDisplayBirthDate"] = this.isDisplayBirthDate;
    data["isDisplayTelegram"] = this.isDisplayTelegram;
    data["isDisplaySkype"] = this.isDisplaySkype;
    data["isDisplayCity"] = this.isDisplayCity;
    data["isDisplayAddress"] = this.isDisplayAddress;
    if (Array.isArray(this.documents)) {
      data["documents"] = [];
      for (let item of this.documents)
        data["documents"].push(item.toJSON());
    }
    data["name"] = this.name;
    data["fullName"] = this.fullName;
    data["phoneNumber"] = this.phoneNumber;
    data["description"] = this.description;
    data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
    data["email"] = this.email;
    data["isDisplayEmail"] = this.isDisplayEmail;
    data["isOracle"] = this.isOracle;
    return data;
  }
}

/** Query model 'Edit personal profile'. */
export interface IEditPersonalProfileViewModel {
  id?: number;
  countryId?: number | undefined;
  birthDate?: Date | undefined;
  city?: string | undefined;
  address?: string | undefined;
  postalCode?: number | undefined;
  province?: string | undefined;
  telegram?: string | undefined;
  skype?: string | undefined;
  isDisplayCountryId?: boolean;
  isDisplayBirthDate?: boolean;
  isDisplayTelegram?: boolean;
  isDisplaySkype?: boolean;
  isDisplayCity?: boolean;
  isDisplayAddress?: boolean;
  documents?: ProfileDocumentViewModel[] | undefined;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  description?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;
}

export class EmailWithConfirmationActionRequest implements IEmailWithConfirmationActionRequest {
  email?: string | undefined;
  confirmationAction?: string | undefined;

  constructor(data?: IEmailWithConfirmationActionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
      this.confirmationAction = _data["confirmationAction"];
    }
  }

  static fromJS(data: any): EmailWithConfirmationActionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new EmailWithConfirmationActionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["email"] = this.email;
    data["confirmationAction"] = this.confirmationAction;
    return data;
  }
}

export interface IEmailWithConfirmationActionRequest {
  email?: string | undefined;
  confirmationAction?: string | undefined;
}

export class EnableTwoFaAsyncRequest implements IEnableTwoFaAsyncRequest {
  code?: string | undefined;

  constructor(data?: IEnableTwoFaAsyncRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
    }
  }

  static fromJS(data: any): EnableTwoFaAsyncRequest {
    data = typeof data === 'object' ? data : {};
    let result = new EnableTwoFaAsyncRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["code"] = this.code;
    return data;
  }
}

export interface IEnableTwoFaAsyncRequest {
  code?: string | undefined;
}

export class EnableTwoFaResponse implements IEnableTwoFaResponse {
  recoveryCodes?: string[] | undefined;

  constructor(data?: IEnableTwoFaResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["recoveryCodes"])) {
        this.recoveryCodes = [] as any;
        for (let item of _data["recoveryCodes"])
          this.recoveryCodes!.push(item);
      }
    }
  }

  static fromJS(data: any): EnableTwoFaResponse {
    data = typeof data === 'object' ? data : {};
    let result = new EnableTwoFaResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.recoveryCodes)) {
      data["recoveryCodes"] = [];
      for (let item of this.recoveryCodes)
        data["recoveryCodes"].push(item);
    }
    return data;
  }
}

export interface IEnableTwoFaResponse {
  recoveryCodes?: string[] | undefined;
}

export class ErrorResponse implements IErrorResponse {
  message?: string | undefined;

  constructor(data?: IErrorResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.message = _data["message"];
    }
  }

  static fromJS(data: any): ErrorResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ErrorResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["message"] = this.message;
    return data;
  }
}

export interface IErrorResponse {
  message?: string | undefined;
}

export class IsAuthorizedRequest implements IIsAuthorizedRequest {
  accessToken?: string | undefined;

  constructor(data?: IIsAuthorizedRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
    }
  }

  static fromJS(data: any): IsAuthorizedRequest {
    data = typeof data === 'object' ? data : {};
    let result = new IsAuthorizedRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["accessToken"] = this.accessToken;
    return data;
  }
}

export interface IIsAuthorizedRequest {
  accessToken?: string | undefined;
}

export class JwtTokenResponse implements IJwtTokenResponse {
  access_token?: string | undefined;
  issued?: Date | undefined;
  expires_in?: number | undefined;
  refresh_token?: string | undefined;

  constructor(data?: IJwtTokenResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.access_token = _data["access_token"];
      this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : <any>undefined;
      this.expires_in = _data["expires_in"];
      this.refresh_token = _data["refresh_token"];
    }
  }

  static fromJS(data: any): JwtTokenResponse {
    data = typeof data === 'object' ? data : {};
    let result = new JwtTokenResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["access_token"] = this.access_token;
    data["issued"] = this.issued ? this.issued.toISOString() : <any>undefined;
    data["expires_in"] = this.expires_in;
    data["refresh_token"] = this.refresh_token;
    return data;
  }
}

export interface IJwtTokenResponse {
  access_token?: string | undefined;
  issued?: Date | undefined;
  expires_in?: number | undefined;
  refresh_token?: string | undefined;
}

export enum KycFieldType {
  Email = "Email",
  FullName = "FullName",
  BirthDate = "BirthDate",
  Country = "Country",
}

export class OAuthRequest implements IOAuthRequest {
  accessToken?: string | undefined;
  system?: OAuthSystem;

  constructor(data?: IOAuthRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
      this.system = _data["system"];
    }
  }

  static fromJS(data: any): OAuthRequest {
    data = typeof data === 'object' ? data : {};
    let result = new OAuthRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["accessToken"] = this.accessToken;
    data["system"] = this.system;
    return data;
  }
}

export interface IOAuthRequest {
  accessToken?: string | undefined;
  system?: OAuthSystem;
}

export enum OAuthSystem {
  Google = "Google",
  Facebook = "Facebook",
  LinkedIn = "LinkedIn",
  Telegram = "Telegram",
  AppleId = "AppleId",
}

export class OAuthTelegramResult implements IOAuthTelegramResult {
  isRegistered?: boolean;

  constructor(data?: IOAuthTelegramResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isRegistered = _data["isRegistered"];
    }
  }

  static fromJS(data: any): OAuthTelegramResult {
    data = typeof data === 'object' ? data : {};
    let result = new OAuthTelegramResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isRegistered"] = this.isRegistered;
    return data;
  }
}

export interface IOAuthTelegramResult {
  isRegistered?: boolean;
}

export class OracleModel implements IOracleModel {
  fullName?: string | undefined;
  description?: string | undefined;
  oracleProfileId?: number;
  isAdded?: boolean;
  isOracle?: boolean;
  avatarUrl?: string | undefined;
  profileType?: AccountType;

  constructor(data?: IOracleModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fullName = _data["fullName"];
      this.description = _data["description"];
      this.oracleProfileId = _data["oracleProfileId"];
      this.isAdded = _data["isAdded"];
      this.isOracle = _data["isOracle"];
      this.avatarUrl = _data["avatarUrl"];
      this.profileType = _data["profileType"];
    }
  }

  static fromJS(data: any): OracleModel {
    data = typeof data === 'object' ? data : {};
    let result = new OracleModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fullName"] = this.fullName;
    data["description"] = this.description;
    data["oracleProfileId"] = this.oracleProfileId;
    data["isAdded"] = this.isAdded;
    data["isOracle"] = this.isOracle;
    data["avatarUrl"] = this.avatarUrl;
    data["profileType"] = this.profileType;
    return data;
  }
}

export interface IOracleModel {
  fullName?: string | undefined;
  description?: string | undefined;
  oracleProfileId?: number;
  isAdded?: boolean;
  isOracle?: boolean;
  avatarUrl?: string | undefined;
  profileType?: AccountType;
}

export class OracleRequest implements IOracleRequest {
  profileId?: number;
  oracleProfileId?: number;

  constructor(data?: IOracleRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.oracleProfileId = _data["oracleProfileId"];
    }
  }

  static fromJS(data: any): OracleRequest {
    data = typeof data === 'object' ? data : {};
    let result = new OracleRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["oracleProfileId"] = this.oracleProfileId;
    return data;
  }
}

export interface IOracleRequest {
  profileId?: number;
  oracleProfileId?: number;
}

export enum OracleTabType {
  All = "All",
  CurrentProfile = "CurrentProfile",
}

export class OraclesResult implements IOraclesResult {
  oracles?: OracleModel[] | undefined;
  totalCount?: number;

  constructor(data?: IOraclesResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["oracles"])) {
        this.oracles = [] as any;
        for (let item of _data["oracles"])
          this.oracles!.push(OracleModel.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): OraclesResult {
    data = typeof data === 'object' ? data : {};
    let result = new OraclesResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.oracles)) {
      data["oracles"] = [];
      for (let item of this.oracles)
        data["oracles"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }
}

export interface IOraclesResult {
  oracles?: OracleModel[] | undefined;
  totalCount?: number;
}

export class OrganizationAgent implements IOrganizationAgent {
  organizationProfileId?: number;
  personalProfileId?: number;
  bindDateTime?: Date;
  acceptedDateTime?: Date | undefined;
  requestType?: OrganizationRequestType;
  organizationProfile?: OrganizationProfile;
  personalProfile?: PersonalProfile;
  id?: number;

  constructor(data?: IOrganizationAgent) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.organizationProfileId = _data["organizationProfileId"];
      this.personalProfileId = _data["personalProfileId"];
      this.bindDateTime = _data["bindDateTime"] ? new Date(_data["bindDateTime"].toString()) : <any>undefined;
      this.acceptedDateTime = _data["acceptedDateTime"] ? new Date(_data["acceptedDateTime"].toString()) : <any>undefined;
      this.requestType = _data["requestType"];
      this.organizationProfile = _data["organizationProfile"] ? OrganizationProfile.fromJS(_data["organizationProfile"]) : <any>undefined;
      this.personalProfile = _data["personalProfile"] ? PersonalProfile.fromJS(_data["personalProfile"]) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrganizationAgent {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationAgent();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["organizationProfileId"] = this.organizationProfileId;
    data["personalProfileId"] = this.personalProfileId;
    data["bindDateTime"] = this.bindDateTime ? this.bindDateTime.toISOString() : <any>undefined;
    data["acceptedDateTime"] = this.acceptedDateTime ? this.acceptedDateTime.toISOString() : <any>undefined;
    data["requestType"] = this.requestType;
    data["organizationProfile"] = this.organizationProfile ? this.organizationProfile.toJSON() : <any>undefined;
    data["personalProfile"] = this.personalProfile ? this.personalProfile.toJSON() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IOrganizationAgent {
  organizationProfileId?: number;
  personalProfileId?: number;
  bindDateTime?: Date;
  acceptedDateTime?: Date | undefined;
  requestType?: OrganizationRequestType;
  organizationProfile?: OrganizationProfile;
  personalProfile?: PersonalProfile;
  id?: number;
}

export class OrganizationAgentViewModel implements IOrganizationAgentViewModel {
  organizationProfileId?: number;
  agentProfileId?: number;

  constructor(data?: IOrganizationAgentViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.organizationProfileId = _data["organizationProfileId"];
      this.agentProfileId = _data["agentProfileId"];
    }
  }

  static fromJS(data: any): OrganizationAgentViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationAgentViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["organizationProfileId"] = this.organizationProfileId;
    data["agentProfileId"] = this.agentProfileId;
    return data;
  }
}

export interface IOrganizationAgentViewModel {
  organizationProfileId?: number;
  agentProfileId?: number;
}

export class OrganizationProfile implements IOrganizationProfile {
  typeOrganization?: string | undefined;
  tin?: string | undefined;
  phoneCompany?: string | undefined;
  registrationAddress?: string | undefined;
  psrn?: string | undefined;
  license?: string | undefined;
  isDisplayTypeOrganization?: boolean | undefined;
  isDisplayTin?: boolean | undefined;
  isDisplayPhoneCompany?: boolean | undefined;
  isDisplayRegistrationAddress?: boolean | undefined;
  isDisplayPsrn?: boolean | undefined;
  isDisplayLicense?: boolean | undefined;
  agents?: OrganizationAgent[] | undefined;
  avatarUrl?: string | undefined;
  name?: string | undefined;
  isDefault?: boolean;
  isOracle?: boolean;
  userId?: string;
  email?: string | undefined;
  isDisplayEmail?: boolean | undefined;
  createDate?: Date;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  isDisplayPhoneNumber?: boolean | undefined;
  description?: string | undefined;
  deletedDate?: Date | undefined;
  fingerprint?: string | undefined;
  priority?: number;
  user?: User;
  contractors?: ProfilesContractor[] | undefined;
  oracles?: ProfilesOracle[] | undefined;
  subscribers?: Subscription[] | undefined;
  subscriptions?: Subscription[] | undefined;
  profilesOracles?: ProfilesOracle[] | undefined;
  profilesContractors?: ProfilesContractor[] | undefined;
  profileUnconfirmedEmails?: ProfileUnconfirmedEmail[] | undefined;
  id?: number;

  constructor(data?: IOrganizationProfile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.typeOrganization = _data["typeOrganization"];
      this.tin = _data["tin"];
      this.phoneCompany = _data["phoneCompany"];
      this.registrationAddress = _data["registrationAddress"];
      this.psrn = _data["psrn"];
      this.license = _data["license"];
      this.isDisplayTypeOrganization = _data["isDisplayTypeOrganization"];
      this.isDisplayTin = _data["isDisplayTin"];
      this.isDisplayPhoneCompany = _data["isDisplayPhoneCompany"];
      this.isDisplayRegistrationAddress = _data["isDisplayRegistrationAddress"];
      this.isDisplayPsrn = _data["isDisplayPsrn"];
      this.isDisplayLicense = _data["isDisplayLicense"];
      if (Array.isArray(_data["agents"])) {
        this.agents = [] as any;
        for (let item of _data["agents"])
          this.agents!.push(OrganizationAgent.fromJS(item));
      }
      this.avatarUrl = _data["avatarUrl"];
      this.name = _data["name"];
      this.isDefault = _data["isDefault"];
      this.isOracle = _data["isOracle"];
      this.userId = _data["userId"];
      this.email = _data["email"];
      this.isDisplayEmail = _data["isDisplayEmail"];
      this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
      this.fullName = _data["fullName"];
      this.phoneNumber = _data["phoneNumber"];
      this.isDisplayPhoneNumber = _data["isDisplayPhoneNumber"];
      this.description = _data["description"];
      this.deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : <any>undefined;
      this.fingerprint = _data["fingerprint"];
      this.priority = _data["priority"];
      this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
      if (Array.isArray(_data["contractors"])) {
        this.contractors = [] as any;
        for (let item of _data["contractors"])
          this.contractors!.push(ProfilesContractor.fromJS(item));
      }
      if (Array.isArray(_data["oracles"])) {
        this.oracles = [] as any;
        for (let item of _data["oracles"])
          this.oracles!.push(ProfilesOracle.fromJS(item));
      }
      if (Array.isArray(_data["subscribers"])) {
        this.subscribers = [] as any;
        for (let item of _data["subscribers"])
          this.subscribers!.push(Subscription.fromJS(item));
      }
      if (Array.isArray(_data["subscriptions"])) {
        this.subscriptions = [] as any;
        for (let item of _data["subscriptions"])
          this.subscriptions!.push(Subscription.fromJS(item));
      }
      if (Array.isArray(_data["profilesOracles"])) {
        this.profilesOracles = [] as any;
        for (let item of _data["profilesOracles"])
          this.profilesOracles!.push(ProfilesOracle.fromJS(item));
      }
      if (Array.isArray(_data["profilesContractors"])) {
        this.profilesContractors = [] as any;
        for (let item of _data["profilesContractors"])
          this.profilesContractors!.push(ProfilesContractor.fromJS(item));
      }
      if (Array.isArray(_data["profileUnconfirmedEmails"])) {
        this.profileUnconfirmedEmails = [] as any;
        for (let item of _data["profileUnconfirmedEmails"])
          this.profileUnconfirmedEmails!.push(ProfileUnconfirmedEmail.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrganizationProfile {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationProfile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["typeOrganization"] = this.typeOrganization;
    data["tin"] = this.tin;
    data["phoneCompany"] = this.phoneCompany;
    data["registrationAddress"] = this.registrationAddress;
    data["psrn"] = this.psrn;
    data["license"] = this.license;
    data["isDisplayTypeOrganization"] = this.isDisplayTypeOrganization;
    data["isDisplayTin"] = this.isDisplayTin;
    data["isDisplayPhoneCompany"] = this.isDisplayPhoneCompany;
    data["isDisplayRegistrationAddress"] = this.isDisplayRegistrationAddress;
    data["isDisplayPsrn"] = this.isDisplayPsrn;
    data["isDisplayLicense"] = this.isDisplayLicense;
    if (Array.isArray(this.agents)) {
      data["agents"] = [];
      for (let item of this.agents)
        data["agents"].push(item.toJSON());
    }
    data["avatarUrl"] = this.avatarUrl;
    data["name"] = this.name;
    data["isDefault"] = this.isDefault;
    data["isOracle"] = this.isOracle;
    data["userId"] = this.userId;
    data["email"] = this.email;
    data["isDisplayEmail"] = this.isDisplayEmail;
    data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
    data["fullName"] = this.fullName;
    data["phoneNumber"] = this.phoneNumber;
    data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
    data["description"] = this.description;
    data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>undefined;
    data["fingerprint"] = this.fingerprint;
    data["priority"] = this.priority;
    data["user"] = this.user ? this.user.toJSON() : <any>undefined;
    if (Array.isArray(this.contractors)) {
      data["contractors"] = [];
      for (let item of this.contractors)
        data["contractors"].push(item.toJSON());
    }
    if (Array.isArray(this.oracles)) {
      data["oracles"] = [];
      for (let item of this.oracles)
        data["oracles"].push(item.toJSON());
    }
    if (Array.isArray(this.subscribers)) {
      data["subscribers"] = [];
      for (let item of this.subscribers)
        data["subscribers"].push(item.toJSON());
    }
    if (Array.isArray(this.subscriptions)) {
      data["subscriptions"] = [];
      for (let item of this.subscriptions)
        data["subscriptions"].push(item.toJSON());
    }
    if (Array.isArray(this.profilesOracles)) {
      data["profilesOracles"] = [];
      for (let item of this.profilesOracles)
        data["profilesOracles"].push(item.toJSON());
    }
    if (Array.isArray(this.profilesContractors)) {
      data["profilesContractors"] = [];
      for (let item of this.profilesContractors)
        data["profilesContractors"].push(item.toJSON());
    }
    if (Array.isArray(this.profileUnconfirmedEmails)) {
      data["profileUnconfirmedEmails"] = [];
      for (let item of this.profileUnconfirmedEmails)
        data["profileUnconfirmedEmails"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }
}

export interface IOrganizationProfile {
  typeOrganization?: string | undefined;
  tin?: string | undefined;
  phoneCompany?: string | undefined;
  registrationAddress?: string | undefined;
  psrn?: string | undefined;
  license?: string | undefined;
  isDisplayTypeOrganization?: boolean | undefined;
  isDisplayTin?: boolean | undefined;
  isDisplayPhoneCompany?: boolean | undefined;
  isDisplayRegistrationAddress?: boolean | undefined;
  isDisplayPsrn?: boolean | undefined;
  isDisplayLicense?: boolean | undefined;
  agents?: OrganizationAgent[] | undefined;
  avatarUrl?: string | undefined;
  name?: string | undefined;
  isDefault?: boolean;
  isOracle?: boolean;
  userId?: string;
  email?: string | undefined;
  isDisplayEmail?: boolean | undefined;
  createDate?: Date;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  isDisplayPhoneNumber?: boolean | undefined;
  description?: string | undefined;
  deletedDate?: Date | undefined;
  fingerprint?: string | undefined;
  priority?: number;
  user?: User;
  contractors?: ProfilesContractor[] | undefined;
  oracles?: ProfilesOracle[] | undefined;
  subscribers?: Subscription[] | undefined;
  subscriptions?: Subscription[] | undefined;
  profilesOracles?: ProfilesOracle[] | undefined;
  profilesContractors?: ProfilesContractor[] | undefined;
  profileUnconfirmedEmails?: ProfileUnconfirmedEmail[] | undefined;
  id?: number;
}

export class OrganizationProfileResult implements IOrganizationProfileResult {
  typeOrganization?: string | undefined;
  tin?: string | undefined;
  registrationAddress?: string | undefined;
  phoneCompany?: string | undefined;
  psrn?: string | undefined;
  license?: string | undefined;
  contractorCount?: number | undefined;
  oracleCount?: number | undefined;
  isDisplayTypeOrganization?: boolean;
  isDisplayTin?: boolean;
  isDisplayPhoneCompany?: boolean;
  isDisplayRegistrationAddress?: boolean;
  isDisplayPsrn?: boolean;
  isDisplayLicense?: boolean;
  id?: number;
  avatarUrl?: string | undefined;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;
  description?: string | undefined;
  userId?: string;
  fingerprint?: string | undefined;

  constructor(data?: IOrganizationProfileResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.typeOrganization = _data["typeOrganization"];
      this.tin = _data["tin"];
      this.registrationAddress = _data["registrationAddress"];
      this.phoneCompany = _data["phoneCompany"];
      this.psrn = _data["psrn"];
      this.license = _data["license"];
      this.contractorCount = _data["contractorCount"];
      this.oracleCount = _data["oracleCount"];
      this.isDisplayTypeOrganization = _data["isDisplayTypeOrganization"];
      this.isDisplayTin = _data["isDisplayTin"];
      this.isDisplayPhoneCompany = _data["isDisplayPhoneCompany"];
      this.isDisplayRegistrationAddress = _data["isDisplayRegistrationAddress"];
      this.isDisplayPsrn = _data["isDisplayPsrn"];
      this.isDisplayLicense = _data["isDisplayLicense"];
      this.id = _data["id"];
      this.avatarUrl = _data["avatarUrl"];
      this.name = _data["name"];
      this.fullName = _data["fullName"];
      this.phoneNumber = _data["phoneNumber"];
      this.isDisplayPhoneNumber = _data["isDisplayPhoneNumber"];
      this.email = _data["email"];
      this.isDisplayEmail = _data["isDisplayEmail"];
      this.isOracle = _data["isOracle"];
      this.description = _data["description"];
      this.userId = _data["userId"];
      this.fingerprint = _data["fingerprint"];
    }
  }

  static fromJS(data: any): OrganizationProfileResult {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationProfileResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["typeOrganization"] = this.typeOrganization;
    data["tin"] = this.tin;
    data["registrationAddress"] = this.registrationAddress;
    data["phoneCompany"] = this.phoneCompany;
    data["psrn"] = this.psrn;
    data["license"] = this.license;
    data["contractorCount"] = this.contractorCount;
    data["oracleCount"] = this.oracleCount;
    data["isDisplayTypeOrganization"] = this.isDisplayTypeOrganization;
    data["isDisplayTin"] = this.isDisplayTin;
    data["isDisplayPhoneCompany"] = this.isDisplayPhoneCompany;
    data["isDisplayRegistrationAddress"] = this.isDisplayRegistrationAddress;
    data["isDisplayPsrn"] = this.isDisplayPsrn;
    data["isDisplayLicense"] = this.isDisplayLicense;
    data["id"] = this.id;
    data["avatarUrl"] = this.avatarUrl;
    data["name"] = this.name;
    data["fullName"] = this.fullName;
    data["phoneNumber"] = this.phoneNumber;
    data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
    data["email"] = this.email;
    data["isDisplayEmail"] = this.isDisplayEmail;
    data["isOracle"] = this.isOracle;
    data["description"] = this.description;
    data["userId"] = this.userId;
    data["fingerprint"] = this.fingerprint;
    return data;
  }
}

export interface IOrganizationProfileResult {
  typeOrganization?: string | undefined;
  tin?: string | undefined;
  registrationAddress?: string | undefined;
  phoneCompany?: string | undefined;
  psrn?: string | undefined;
  license?: string | undefined;
  contractorCount?: number | undefined;
  oracleCount?: number | undefined;
  isDisplayTypeOrganization?: boolean;
  isDisplayTin?: boolean;
  isDisplayPhoneCompany?: boolean;
  isDisplayRegistrationAddress?: boolean;
  isDisplayPsrn?: boolean;
  isDisplayLicense?: boolean;
  id?: number;
  avatarUrl?: string | undefined;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;
  description?: string | undefined;
  userId?: string;
  fingerprint?: string | undefined;
}

/** Query model 'Organization profile'. */
export class OrganizationProfileViewModel implements IOrganizationProfileViewModel {
  typeOrganization?: string | undefined;
  tin?: string | undefined;
  phoneCompany?: string | undefined;
  registrationAddress?: string | undefined;
  psrn?: string | undefined;
  license?: string | undefined;
  isDisplayTypeOrganization?: boolean;
  isDisplayTin?: boolean;
  isDisplayPhoneCompany?: boolean;
  isDisplayRegistrationAddress?: boolean;
  isDisplayPsrn?: boolean;
  isDisplayLicense?: boolean;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  description?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;

  constructor(data?: IOrganizationProfileViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.typeOrganization = _data["typeOrganization"];
      this.tin = _data["tin"];
      this.phoneCompany = _data["phoneCompany"];
      this.registrationAddress = _data["registrationAddress"];
      this.psrn = _data["psrn"];
      this.license = _data["license"];
      this.isDisplayTypeOrganization = _data["isDisplayTypeOrganization"];
      this.isDisplayTin = _data["isDisplayTin"];
      this.isDisplayPhoneCompany = _data["isDisplayPhoneCompany"];
      this.isDisplayRegistrationAddress = _data["isDisplayRegistrationAddress"];
      this.isDisplayPsrn = _data["isDisplayPsrn"];
      this.isDisplayLicense = _data["isDisplayLicense"];
      this.name = _data["name"];
      this.fullName = _data["fullName"];
      this.phoneNumber = _data["phoneNumber"];
      this.description = _data["description"];
      this.isDisplayPhoneNumber = _data["isDisplayPhoneNumber"];
      this.email = _data["email"];
      this.isDisplayEmail = _data["isDisplayEmail"];
      this.isOracle = _data["isOracle"];
    }
  }

  static fromJS(data: any): OrganizationProfileViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationProfileViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["typeOrganization"] = this.typeOrganization;
    data["tin"] = this.tin;
    data["phoneCompany"] = this.phoneCompany;
    data["registrationAddress"] = this.registrationAddress;
    data["psrn"] = this.psrn;
    data["license"] = this.license;
    data["isDisplayTypeOrganization"] = this.isDisplayTypeOrganization;
    data["isDisplayTin"] = this.isDisplayTin;
    data["isDisplayPhoneCompany"] = this.isDisplayPhoneCompany;
    data["isDisplayRegistrationAddress"] = this.isDisplayRegistrationAddress;
    data["isDisplayPsrn"] = this.isDisplayPsrn;
    data["isDisplayLicense"] = this.isDisplayLicense;
    data["name"] = this.name;
    data["fullName"] = this.fullName;
    data["phoneNumber"] = this.phoneNumber;
    data["description"] = this.description;
    data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
    data["email"] = this.email;
    data["isDisplayEmail"] = this.isDisplayEmail;
    data["isOracle"] = this.isOracle;
    return data;
  }
}

/** Query model 'Organization profile'. */
export interface IOrganizationProfileViewModel {
  typeOrganization?: string | undefined;
  tin?: string | undefined;
  phoneCompany?: string | undefined;
  registrationAddress?: string | undefined;
  psrn?: string | undefined;
  license?: string | undefined;
  isDisplayTypeOrganization?: boolean;
  isDisplayTin?: boolean;
  isDisplayPhoneCompany?: boolean;
  isDisplayRegistrationAddress?: boolean;
  isDisplayPsrn?: boolean;
  isDisplayLicense?: boolean;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  description?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;
}

export enum OrganizationRequestType {
  Requested = "Requested",
  Accepted = "Accepted",
  Rejected = "Rejected",
  Canceled = "Canceled",
  Unbind = "Unbind",
  Deleted = "Deleted",
}

export class OrganizationResult implements IOrganizationResult {
  id?: number;
  avatarUrl?: string | undefined;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;
  description?: string | undefined;
  userId?: string;
  fingerprint?: string | undefined;

  constructor(data?: IOrganizationResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.avatarUrl = _data["avatarUrl"];
      this.name = _data["name"];
      this.fullName = _data["fullName"];
      this.phoneNumber = _data["phoneNumber"];
      this.isDisplayPhoneNumber = _data["isDisplayPhoneNumber"];
      this.email = _data["email"];
      this.isDisplayEmail = _data["isDisplayEmail"];
      this.isOracle = _data["isOracle"];
      this.description = _data["description"];
      this.userId = _data["userId"];
      this.fingerprint = _data["fingerprint"];
    }
  }

  static fromJS(data: any): OrganizationResult {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["avatarUrl"] = this.avatarUrl;
    data["name"] = this.name;
    data["fullName"] = this.fullName;
    data["phoneNumber"] = this.phoneNumber;
    data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
    data["email"] = this.email;
    data["isDisplayEmail"] = this.isDisplayEmail;
    data["isOracle"] = this.isOracle;
    data["description"] = this.description;
    data["userId"] = this.userId;
    data["fingerprint"] = this.fingerprint;
    return data;
  }
}

export interface IOrganizationResult {
  id?: number;
  avatarUrl?: string | undefined;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;
  description?: string | undefined;
  userId?: string;
  fingerprint?: string | undefined;
}

export class ParticipantsResult implements IParticipantsResult {
  participants?: ContractorModel[] | undefined;
  totalCount?: number;

  constructor(data?: IParticipantsResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["participants"])) {
        this.participants = [] as any;
        for (let item of _data["participants"])
          this.participants!.push(ContractorModel.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): ParticipantsResult {
    data = typeof data === 'object' ? data : {};
    let result = new ParticipantsResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.participants)) {
      data["participants"] = [];
      for (let item of this.participants)
        data["participants"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }
}

export interface IParticipantsResult {
  participants?: ContractorModel[] | undefined;
  totalCount?: number;
}

export class PersonalProfile implements IPersonalProfile {
  birthDate?: Date | undefined;
  city?: string | undefined;
  address?: string | undefined;
  postalCode?: number | undefined;
  province?: string | undefined;
  telegram?: string | undefined;
  skype?: string | undefined;
  isDisplayCountryId?: boolean | undefined;
  isDisplayBirthDate?: boolean | undefined;
  isDisplayTelegram?: boolean | undefined;
  isDisplaySkype?: boolean | undefined;
  isDisplayCity?: boolean | undefined;
  isDisplayAddress?: boolean | undefined;
  countryId?: number | undefined;
  country?: Country;
  organizations?: OrganizationAgent[] | undefined;
  profileDocuments?: ProfileDocument[] | undefined;
  profileDocumentPatterns?: ProfileDocumentPattern[] | undefined;
  avatarUrl?: string | undefined;
  name?: string | undefined;
  isDefault?: boolean;
  isOracle?: boolean;
  userId?: string;
  email?: string | undefined;
  isDisplayEmail?: boolean | undefined;
  createDate?: Date;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  isDisplayPhoneNumber?: boolean | undefined;
  description?: string | undefined;
  deletedDate?: Date | undefined;
  fingerprint?: string | undefined;
  priority?: number;
  user?: User;
  contractors?: ProfilesContractor[] | undefined;
  oracles?: ProfilesOracle[] | undefined;
  subscribers?: Subscription[] | undefined;
  subscriptions?: Subscription[] | undefined;
  profilesOracles?: ProfilesOracle[] | undefined;
  profilesContractors?: ProfilesContractor[] | undefined;
  profileUnconfirmedEmails?: ProfileUnconfirmedEmail[] | undefined;
  id?: number;

  constructor(data?: IPersonalProfile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
      this.city = _data["city"];
      this.address = _data["address"];
      this.postalCode = _data["postalCode"];
      this.province = _data["province"];
      this.telegram = _data["telegram"];
      this.skype = _data["skype"];
      this.isDisplayCountryId = _data["isDisplayCountryId"];
      this.isDisplayBirthDate = _data["isDisplayBirthDate"];
      this.isDisplayTelegram = _data["isDisplayTelegram"];
      this.isDisplaySkype = _data["isDisplaySkype"];
      this.isDisplayCity = _data["isDisplayCity"];
      this.isDisplayAddress = _data["isDisplayAddress"];
      this.countryId = _data["countryId"];
      this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
      if (Array.isArray(_data["organizations"])) {
        this.organizations = [] as any;
        for (let item of _data["organizations"])
          this.organizations!.push(OrganizationAgent.fromJS(item));
      }
      if (Array.isArray(_data["profileDocuments"])) {
        this.profileDocuments = [] as any;
        for (let item of _data["profileDocuments"])
          this.profileDocuments!.push(ProfileDocument.fromJS(item));
      }
      if (Array.isArray(_data["profileDocumentPatterns"])) {
        this.profileDocumentPatterns = [] as any;
        for (let item of _data["profileDocumentPatterns"])
          this.profileDocumentPatterns!.push(ProfileDocumentPattern.fromJS(item));
      }
      this.avatarUrl = _data["avatarUrl"];
      this.name = _data["name"];
      this.isDefault = _data["isDefault"];
      this.isOracle = _data["isOracle"];
      this.userId = _data["userId"];
      this.email = _data["email"];
      this.isDisplayEmail = _data["isDisplayEmail"];
      this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
      this.fullName = _data["fullName"];
      this.phoneNumber = _data["phoneNumber"];
      this.isDisplayPhoneNumber = _data["isDisplayPhoneNumber"];
      this.description = _data["description"];
      this.deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : <any>undefined;
      this.fingerprint = _data["fingerprint"];
      this.priority = _data["priority"];
      this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
      if (Array.isArray(_data["contractors"])) {
        this.contractors = [] as any;
        for (let item of _data["contractors"])
          this.contractors!.push(ProfilesContractor.fromJS(item));
      }
      if (Array.isArray(_data["oracles"])) {
        this.oracles = [] as any;
        for (let item of _data["oracles"])
          this.oracles!.push(ProfilesOracle.fromJS(item));
      }
      if (Array.isArray(_data["subscribers"])) {
        this.subscribers = [] as any;
        for (let item of _data["subscribers"])
          this.subscribers!.push(Subscription.fromJS(item));
      }
      if (Array.isArray(_data["subscriptions"])) {
        this.subscriptions = [] as any;
        for (let item of _data["subscriptions"])
          this.subscriptions!.push(Subscription.fromJS(item));
      }
      if (Array.isArray(_data["profilesOracles"])) {
        this.profilesOracles = [] as any;
        for (let item of _data["profilesOracles"])
          this.profilesOracles!.push(ProfilesOracle.fromJS(item));
      }
      if (Array.isArray(_data["profilesContractors"])) {
        this.profilesContractors = [] as any;
        for (let item of _data["profilesContractors"])
          this.profilesContractors!.push(ProfilesContractor.fromJS(item));
      }
      if (Array.isArray(_data["profileUnconfirmedEmails"])) {
        this.profileUnconfirmedEmails = [] as any;
        for (let item of _data["profileUnconfirmedEmails"])
          this.profileUnconfirmedEmails!.push(ProfileUnconfirmedEmail.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PersonalProfile {
    data = typeof data === 'object' ? data : {};
    let result = new PersonalProfile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
    data["city"] = this.city;
    data["address"] = this.address;
    data["postalCode"] = this.postalCode;
    data["province"] = this.province;
    data["telegram"] = this.telegram;
    data["skype"] = this.skype;
    data["isDisplayCountryId"] = this.isDisplayCountryId;
    data["isDisplayBirthDate"] = this.isDisplayBirthDate;
    data["isDisplayTelegram"] = this.isDisplayTelegram;
    data["isDisplaySkype"] = this.isDisplaySkype;
    data["isDisplayCity"] = this.isDisplayCity;
    data["isDisplayAddress"] = this.isDisplayAddress;
    data["countryId"] = this.countryId;
    data["country"] = this.country ? this.country.toJSON() : <any>undefined;
    if (Array.isArray(this.organizations)) {
      data["organizations"] = [];
      for (let item of this.organizations)
        data["organizations"].push(item.toJSON());
    }
    if (Array.isArray(this.profileDocuments)) {
      data["profileDocuments"] = [];
      for (let item of this.profileDocuments)
        data["profileDocuments"].push(item.toJSON());
    }
    if (Array.isArray(this.profileDocumentPatterns)) {
      data["profileDocumentPatterns"] = [];
      for (let item of this.profileDocumentPatterns)
        data["profileDocumentPatterns"].push(item.toJSON());
    }
    data["avatarUrl"] = this.avatarUrl;
    data["name"] = this.name;
    data["isDefault"] = this.isDefault;
    data["isOracle"] = this.isOracle;
    data["userId"] = this.userId;
    data["email"] = this.email;
    data["isDisplayEmail"] = this.isDisplayEmail;
    data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
    data["fullName"] = this.fullName;
    data["phoneNumber"] = this.phoneNumber;
    data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
    data["description"] = this.description;
    data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>undefined;
    data["fingerprint"] = this.fingerprint;
    data["priority"] = this.priority;
    data["user"] = this.user ? this.user.toJSON() : <any>undefined;
    if (Array.isArray(this.contractors)) {
      data["contractors"] = [];
      for (let item of this.contractors)
        data["contractors"].push(item.toJSON());
    }
    if (Array.isArray(this.oracles)) {
      data["oracles"] = [];
      for (let item of this.oracles)
        data["oracles"].push(item.toJSON());
    }
    if (Array.isArray(this.subscribers)) {
      data["subscribers"] = [];
      for (let item of this.subscribers)
        data["subscribers"].push(item.toJSON());
    }
    if (Array.isArray(this.subscriptions)) {
      data["subscriptions"] = [];
      for (let item of this.subscriptions)
        data["subscriptions"].push(item.toJSON());
    }
    if (Array.isArray(this.profilesOracles)) {
      data["profilesOracles"] = [];
      for (let item of this.profilesOracles)
        data["profilesOracles"].push(item.toJSON());
    }
    if (Array.isArray(this.profilesContractors)) {
      data["profilesContractors"] = [];
      for (let item of this.profilesContractors)
        data["profilesContractors"].push(item.toJSON());
    }
    if (Array.isArray(this.profileUnconfirmedEmails)) {
      data["profileUnconfirmedEmails"] = [];
      for (let item of this.profileUnconfirmedEmails)
        data["profileUnconfirmedEmails"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }
}

export interface IPersonalProfile {
  birthDate?: Date | undefined;
  city?: string | undefined;
  address?: string | undefined;
  postalCode?: number | undefined;
  province?: string | undefined;
  telegram?: string | undefined;
  skype?: string | undefined;
  isDisplayCountryId?: boolean | undefined;
  isDisplayBirthDate?: boolean | undefined;
  isDisplayTelegram?: boolean | undefined;
  isDisplaySkype?: boolean | undefined;
  isDisplayCity?: boolean | undefined;
  isDisplayAddress?: boolean | undefined;
  countryId?: number | undefined;
  country?: Country;
  organizations?: OrganizationAgent[] | undefined;
  profileDocuments?: ProfileDocument[] | undefined;
  profileDocumentPatterns?: ProfileDocumentPattern[] | undefined;
  avatarUrl?: string | undefined;
  name?: string | undefined;
  isDefault?: boolean;
  isOracle?: boolean;
  userId?: string;
  email?: string | undefined;
  isDisplayEmail?: boolean | undefined;
  createDate?: Date;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  isDisplayPhoneNumber?: boolean | undefined;
  description?: string | undefined;
  deletedDate?: Date | undefined;
  fingerprint?: string | undefined;
  priority?: number;
  user?: User;
  contractors?: ProfilesContractor[] | undefined;
  oracles?: ProfilesOracle[] | undefined;
  subscribers?: Subscription[] | undefined;
  subscriptions?: Subscription[] | undefined;
  profilesOracles?: ProfilesOracle[] | undefined;
  profilesContractors?: ProfilesContractor[] | undefined;
  profileUnconfirmedEmails?: ProfileUnconfirmedEmail[] | undefined;
  id?: number;
}

export class PersonalProfileResult implements IPersonalProfileResult {
  countryId?: number | undefined;
  countryName?: string | undefined;
  country2Code?: string | undefined;
  contractorCount?: number | undefined;
  oracleCount?: number | undefined;
  birthDate?: Date | undefined;
  city?: string | undefined;
  address?: string | undefined;
  postalCode?: number | undefined;
  province?: string | undefined;
  telegram?: string | undefined;
  skype?: string | undefined;
  isDisplayCountryId?: boolean;
  isDisplayBirthDate?: boolean;
  isDisplayTelegram?: boolean;
  isDisplaySkype?: boolean;
  isDisplayCity?: boolean;
  isDisplayAddress?: boolean;
  documents?: ProfileDocumentResult[] | undefined;
  id?: number;
  avatarUrl?: string | undefined;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;
  description?: string | undefined;
  userId?: string;
  fingerprint?: string | undefined;

  constructor(data?: IPersonalProfileResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.countryId = _data["countryId"];
      this.countryName = _data["countryName"];
      this.country2Code = _data["country2Code"];
      this.contractorCount = _data["contractorCount"];
      this.oracleCount = _data["oracleCount"];
      this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
      this.city = _data["city"];
      this.address = _data["address"];
      this.postalCode = _data["postalCode"];
      this.province = _data["province"];
      this.telegram = _data["telegram"];
      this.skype = _data["skype"];
      this.isDisplayCountryId = _data["isDisplayCountryId"];
      this.isDisplayBirthDate = _data["isDisplayBirthDate"];
      this.isDisplayTelegram = _data["isDisplayTelegram"];
      this.isDisplaySkype = _data["isDisplaySkype"];
      this.isDisplayCity = _data["isDisplayCity"];
      this.isDisplayAddress = _data["isDisplayAddress"];
      if (Array.isArray(_data["documents"])) {
        this.documents = [] as any;
        for (let item of _data["documents"])
          this.documents!.push(ProfileDocumentResult.fromJS(item));
      }
      this.id = _data["id"];
      this.avatarUrl = _data["avatarUrl"];
      this.name = _data["name"];
      this.fullName = _data["fullName"];
      this.phoneNumber = _data["phoneNumber"];
      this.isDisplayPhoneNumber = _data["isDisplayPhoneNumber"];
      this.email = _data["email"];
      this.isDisplayEmail = _data["isDisplayEmail"];
      this.isOracle = _data["isOracle"];
      this.description = _data["description"];
      this.userId = _data["userId"];
      this.fingerprint = _data["fingerprint"];
    }
  }

  static fromJS(data: any): PersonalProfileResult {
    data = typeof data === 'object' ? data : {};
    let result = new PersonalProfileResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["countryId"] = this.countryId;
    data["countryName"] = this.countryName;
    data["country2Code"] = this.country2Code;
    data["contractorCount"] = this.contractorCount;
    data["oracleCount"] = this.oracleCount;
    data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
    data["city"] = this.city;
    data["address"] = this.address;
    data["postalCode"] = this.postalCode;
    data["province"] = this.province;
    data["telegram"] = this.telegram;
    data["skype"] = this.skype;
    data["isDisplayCountryId"] = this.isDisplayCountryId;
    data["isDisplayBirthDate"] = this.isDisplayBirthDate;
    data["isDisplayTelegram"] = this.isDisplayTelegram;
    data["isDisplaySkype"] = this.isDisplaySkype;
    data["isDisplayCity"] = this.isDisplayCity;
    data["isDisplayAddress"] = this.isDisplayAddress;
    if (Array.isArray(this.documents)) {
      data["documents"] = [];
      for (let item of this.documents)
        data["documents"].push(item.toJSON());
    }
    data["id"] = this.id;
    data["avatarUrl"] = this.avatarUrl;
    data["name"] = this.name;
    data["fullName"] = this.fullName;
    data["phoneNumber"] = this.phoneNumber;
    data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
    data["email"] = this.email;
    data["isDisplayEmail"] = this.isDisplayEmail;
    data["isOracle"] = this.isOracle;
    data["description"] = this.description;
    data["userId"] = this.userId;
    data["fingerprint"] = this.fingerprint;
    return data;
  }
}

export interface IPersonalProfileResult {
  countryId?: number | undefined;
  countryName?: string | undefined;
  country2Code?: string | undefined;
  contractorCount?: number | undefined;
  oracleCount?: number | undefined;
  birthDate?: Date | undefined;
  city?: string | undefined;
  address?: string | undefined;
  postalCode?: number | undefined;
  province?: string | undefined;
  telegram?: string | undefined;
  skype?: string | undefined;
  isDisplayCountryId?: boolean;
  isDisplayBirthDate?: boolean;
  isDisplayTelegram?: boolean;
  isDisplaySkype?: boolean;
  isDisplayCity?: boolean;
  isDisplayAddress?: boolean;
  documents?: ProfileDocumentResult[] | undefined;
  id?: number;
  avatarUrl?: string | undefined;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;
  description?: string | undefined;
  userId?: string;
  fingerprint?: string | undefined;
}

/** Query model 'Personal profile'. */
export class PersonalProfileViewModel implements IPersonalProfileViewModel {
  countryId?: number | undefined;
  birthDate?: Date | undefined;
  city?: string | undefined;
  address?: string | undefined;
  postalCode?: number | undefined;
  province?: string | undefined;
  telegram?: string | undefined;
  skype?: string | undefined;
  isDisplayCountryId?: boolean;
  isDisplayBirthDate?: boolean;
  isDisplayTelegram?: boolean;
  isDisplaySkype?: boolean;
  isDisplayCity?: boolean;
  isDisplayAddress?: boolean;
  documents?: ProfileDocumentViewModel[] | undefined;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  description?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;

  constructor(data?: IPersonalProfileViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.countryId = _data["countryId"];
      this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
      this.city = _data["city"];
      this.address = _data["address"];
      this.postalCode = _data["postalCode"];
      this.province = _data["province"];
      this.telegram = _data["telegram"];
      this.skype = _data["skype"];
      this.isDisplayCountryId = _data["isDisplayCountryId"];
      this.isDisplayBirthDate = _data["isDisplayBirthDate"];
      this.isDisplayTelegram = _data["isDisplayTelegram"];
      this.isDisplaySkype = _data["isDisplaySkype"];
      this.isDisplayCity = _data["isDisplayCity"];
      this.isDisplayAddress = _data["isDisplayAddress"];
      if (Array.isArray(_data["documents"])) {
        this.documents = [] as any;
        for (let item of _data["documents"])
          this.documents!.push(ProfileDocumentViewModel.fromJS(item));
      }
      this.name = _data["name"];
      this.fullName = _data["fullName"];
      this.phoneNumber = _data["phoneNumber"];
      this.description = _data["description"];
      this.isDisplayPhoneNumber = _data["isDisplayPhoneNumber"];
      this.email = _data["email"];
      this.isDisplayEmail = _data["isDisplayEmail"];
      this.isOracle = _data["isOracle"];
    }
  }

  static fromJS(data: any): PersonalProfileViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new PersonalProfileViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["countryId"] = this.countryId;
    data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
    data["city"] = this.city;
    data["address"] = this.address;
    data["postalCode"] = this.postalCode;
    data["province"] = this.province;
    data["telegram"] = this.telegram;
    data["skype"] = this.skype;
    data["isDisplayCountryId"] = this.isDisplayCountryId;
    data["isDisplayBirthDate"] = this.isDisplayBirthDate;
    data["isDisplayTelegram"] = this.isDisplayTelegram;
    data["isDisplaySkype"] = this.isDisplaySkype;
    data["isDisplayCity"] = this.isDisplayCity;
    data["isDisplayAddress"] = this.isDisplayAddress;
    if (Array.isArray(this.documents)) {
      data["documents"] = [];
      for (let item of this.documents)
        data["documents"].push(item.toJSON());
    }
    data["name"] = this.name;
    data["fullName"] = this.fullName;
    data["phoneNumber"] = this.phoneNumber;
    data["description"] = this.description;
    data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
    data["email"] = this.email;
    data["isDisplayEmail"] = this.isDisplayEmail;
    data["isOracle"] = this.isOracle;
    return data;
  }
}

/** Query model 'Personal profile'. */
export interface IPersonalProfileViewModel {
  countryId?: number | undefined;
  birthDate?: Date | undefined;
  city?: string | undefined;
  address?: string | undefined;
  postalCode?: number | undefined;
  province?: string | undefined;
  telegram?: string | undefined;
  skype?: string | undefined;
  isDisplayCountryId?: boolean;
  isDisplayBirthDate?: boolean;
  isDisplayTelegram?: boolean;
  isDisplaySkype?: boolean;
  isDisplayCity?: boolean;
  isDisplayAddress?: boolean;
  documents?: ProfileDocumentViewModel[] | undefined;
  name?: string | undefined;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  description?: string | undefined;
  isDisplayPhoneNumber?: boolean;
  email?: string | undefined;
  isDisplayEmail?: boolean;
  isOracle?: boolean;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class Profile implements IProfile {
  avatarUrl?: string | undefined;
  name?: string | undefined;
  isDefault?: boolean;
  isOracle?: boolean;
  userId?: string;
  email?: string | undefined;
  isDisplayEmail?: boolean | undefined;
  createDate?: Date;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  isDisplayPhoneNumber?: boolean | undefined;
  description?: string | undefined;
  deletedDate?: Date | undefined;
  fingerprint?: string | undefined;
  priority?: number;
  user?: User;
  contractors?: ProfilesContractor[] | undefined;
  oracles?: ProfilesOracle[] | undefined;
  subscribers?: Subscription[] | undefined;
  subscriptions?: Subscription[] | undefined;
  profilesOracles?: ProfilesOracle[] | undefined;
  profilesContractors?: ProfilesContractor[] | undefined;
  profileUnconfirmedEmails?: ProfileUnconfirmedEmail[] | undefined;
  id?: number;

  constructor(data?: IProfile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.avatarUrl = _data["avatarUrl"];
      this.name = _data["name"];
      this.isDefault = _data["isDefault"];
      this.isOracle = _data["isOracle"];
      this.userId = _data["userId"];
      this.email = _data["email"];
      this.isDisplayEmail = _data["isDisplayEmail"];
      this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
      this.fullName = _data["fullName"];
      this.phoneNumber = _data["phoneNumber"];
      this.isDisplayPhoneNumber = _data["isDisplayPhoneNumber"];
      this.description = _data["description"];
      this.deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : <any>undefined;
      this.fingerprint = _data["fingerprint"];
      this.priority = _data["priority"];
      this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
      if (Array.isArray(_data["contractors"])) {
        this.contractors = [] as any;
        for (let item of _data["contractors"])
          this.contractors!.push(ProfilesContractor.fromJS(item));
      }
      if (Array.isArray(_data["oracles"])) {
        this.oracles = [] as any;
        for (let item of _data["oracles"])
          this.oracles!.push(ProfilesOracle.fromJS(item));
      }
      if (Array.isArray(_data["subscribers"])) {
        this.subscribers = [] as any;
        for (let item of _data["subscribers"])
          this.subscribers!.push(Subscription.fromJS(item));
      }
      if (Array.isArray(_data["subscriptions"])) {
        this.subscriptions = [] as any;
        for (let item of _data["subscriptions"])
          this.subscriptions!.push(Subscription.fromJS(item));
      }
      if (Array.isArray(_data["profilesOracles"])) {
        this.profilesOracles = [] as any;
        for (let item of _data["profilesOracles"])
          this.profilesOracles!.push(ProfilesOracle.fromJS(item));
      }
      if (Array.isArray(_data["profilesContractors"])) {
        this.profilesContractors = [] as any;
        for (let item of _data["profilesContractors"])
          this.profilesContractors!.push(ProfilesContractor.fromJS(item));
      }
      if (Array.isArray(_data["profileUnconfirmedEmails"])) {
        this.profileUnconfirmedEmails = [] as any;
        for (let item of _data["profileUnconfirmedEmails"])
          this.profileUnconfirmedEmails!.push(ProfileUnconfirmedEmail.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Profile {
    data = typeof data === 'object' ? data : {};
    let result = new Profile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["avatarUrl"] = this.avatarUrl;
    data["name"] = this.name;
    data["isDefault"] = this.isDefault;
    data["isOracle"] = this.isOracle;
    data["userId"] = this.userId;
    data["email"] = this.email;
    data["isDisplayEmail"] = this.isDisplayEmail;
    data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
    data["fullName"] = this.fullName;
    data["phoneNumber"] = this.phoneNumber;
    data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
    data["description"] = this.description;
    data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>undefined;
    data["fingerprint"] = this.fingerprint;
    data["priority"] = this.priority;
    data["user"] = this.user ? this.user.toJSON() : <any>undefined;
    if (Array.isArray(this.contractors)) {
      data["contractors"] = [];
      for (let item of this.contractors)
        data["contractors"].push(item.toJSON());
    }
    if (Array.isArray(this.oracles)) {
      data["oracles"] = [];
      for (let item of this.oracles)
        data["oracles"].push(item.toJSON());
    }
    if (Array.isArray(this.subscribers)) {
      data["subscribers"] = [];
      for (let item of this.subscribers)
        data["subscribers"].push(item.toJSON());
    }
    if (Array.isArray(this.subscriptions)) {
      data["subscriptions"] = [];
      for (let item of this.subscriptions)
        data["subscriptions"].push(item.toJSON());
    }
    if (Array.isArray(this.profilesOracles)) {
      data["profilesOracles"] = [];
      for (let item of this.profilesOracles)
        data["profilesOracles"].push(item.toJSON());
    }
    if (Array.isArray(this.profilesContractors)) {
      data["profilesContractors"] = [];
      for (let item of this.profilesContractors)
        data["profilesContractors"].push(item.toJSON());
    }
    if (Array.isArray(this.profileUnconfirmedEmails)) {
      data["profileUnconfirmedEmails"] = [];
      for (let item of this.profileUnconfirmedEmails)
        data["profileUnconfirmedEmails"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }
}

export interface IProfile {
  avatarUrl?: string | undefined;
  name?: string | undefined;
  isDefault?: boolean;
  isOracle?: boolean;
  userId?: string;
  email?: string | undefined;
  isDisplayEmail?: boolean | undefined;
  createDate?: Date;
  fullName?: string | undefined;
  phoneNumber?: string | undefined;
  isDisplayPhoneNumber?: boolean | undefined;
  description?: string | undefined;
  deletedDate?: Date | undefined;
  fingerprint?: string | undefined;
  priority?: number;
  user?: User;
  contractors?: ProfilesContractor[] | undefined;
  oracles?: ProfilesOracle[] | undefined;
  subscribers?: Subscription[] | undefined;
  subscriptions?: Subscription[] | undefined;
  profilesOracles?: ProfilesOracle[] | undefined;
  profilesContractors?: ProfilesContractor[] | undefined;
  profileUnconfirmedEmails?: ProfileUnconfirmedEmail[] | undefined;
  id?: number;
}

export class ProfileDocument implements IProfileDocument {
  profileId?: number | undefined;
  countryId?: number | undefined;
  documentType?: DocumentType;
  documentNumber?: string | undefined;
  documentSurname?: string | undefined;
  documentName?: string | undefined;
  documentBirthDate?: Date | undefined;
  documentIssuedDate?: Date | undefined;
  documentAuthority?: string | undefined;
  documentExpiryDate?: Date | undefined;
  documentBirthPlace?: string | undefined;
  documentNationality?: string | undefined;
  documentSex?: string | undefined;
  documentAddress?: string | undefined;
  documentPersonalNumber?: string | undefined;
  documentHeight?: string | undefined;
  documentCharType?: string | undefined;
  documentCountryCode?: string | undefined;
  documentResidence?: string | undefined;
  documentCardName?: string | undefined;
  documentReligion?: string | undefined;
  documentCardAdministrative?: string | undefined;
  documentCardPIN?: string | undefined;
  documentStartDate?: Date | undefined;
  driverLicenseCategory?: string | undefined;
  driverAlamat?: string | undefined;
  driverTempat?: string | undefined;
  driverPekerjaan?: string | undefined;
  driverSIM?: string | undefined;
  driverBerlaku?: string | undefined;
  driverProvinceCode?: string | undefined;
  driverPlaceRegistration?: string | undefined;
  driverDateRegistration?: Date | undefined;
  driverHeadquarter?: string | undefined;
  driverConditions?: string | undefined;
  driverClass?: string | undefined;
  isDisplayDocument?: boolean;
  deletedDate?: Date | undefined;
  country?: Country;
  profile?: PersonalProfile;
  id?: number;

  constructor(data?: IProfileDocument) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.countryId = _data["countryId"];
      this.documentType = _data["documentType"];
      this.documentNumber = _data["documentNumber"];
      this.documentSurname = _data["documentSurname"];
      this.documentName = _data["documentName"];
      this.documentBirthDate = _data["documentBirthDate"] ? new Date(_data["documentBirthDate"].toString()) : <any>undefined;
      this.documentIssuedDate = _data["documentIssuedDate"] ? new Date(_data["documentIssuedDate"].toString()) : <any>undefined;
      this.documentAuthority = _data["documentAuthority"];
      this.documentExpiryDate = _data["documentExpiryDate"] ? new Date(_data["documentExpiryDate"].toString()) : <any>undefined;
      this.documentBirthPlace = _data["documentBirthPlace"];
      this.documentNationality = _data["documentNationality"];
      this.documentSex = _data["documentSex"];
      this.documentAddress = _data["documentAddress"];
      this.documentPersonalNumber = _data["documentPersonalNumber"];
      this.documentHeight = _data["documentHeight"];
      this.documentCharType = _data["documentCharType"];
      this.documentCountryCode = _data["documentCountryCode"];
      this.documentResidence = _data["documentResidence"];
      this.documentCardName = _data["documentCardName"];
      this.documentReligion = _data["documentReligion"];
      this.documentCardAdministrative = _data["documentCardAdministrative"];
      this.documentCardPIN = _data["documentCardPIN"];
      this.documentStartDate = _data["documentStartDate"] ? new Date(_data["documentStartDate"].toString()) : <any>undefined;
      this.driverLicenseCategory = _data["driverLicenseCategory"];
      this.driverAlamat = _data["driverAlamat"];
      this.driverTempat = _data["driverTempat"];
      this.driverPekerjaan = _data["driverPekerjaan"];
      this.driverSIM = _data["driverSIM"];
      this.driverBerlaku = _data["driverBerlaku"];
      this.driverProvinceCode = _data["driverProvinceCode"];
      this.driverPlaceRegistration = _data["driverPlaceRegistration"];
      this.driverDateRegistration = _data["driverDateRegistration"] ? new Date(_data["driverDateRegistration"].toString()) : <any>undefined;
      this.driverHeadquarter = _data["driverHeadquarter"];
      this.driverConditions = _data["driverConditions"];
      this.driverClass = _data["driverClass"];
      this.isDisplayDocument = _data["isDisplayDocument"];
      this.deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : <any>undefined;
      this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
      this.profile = _data["profile"] ? PersonalProfile.fromJS(_data["profile"]) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProfileDocument {
    data = typeof data === 'object' ? data : {};
    let result = new ProfileDocument();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["countryId"] = this.countryId;
    data["documentType"] = this.documentType;
    data["documentNumber"] = this.documentNumber;
    data["documentSurname"] = this.documentSurname;
    data["documentName"] = this.documentName;
    data["documentBirthDate"] = this.documentBirthDate ? this.documentBirthDate.toISOString() : <any>undefined;
    data["documentIssuedDate"] = this.documentIssuedDate ? this.documentIssuedDate.toISOString() : <any>undefined;
    data["documentAuthority"] = this.documentAuthority;
    data["documentExpiryDate"] = this.documentExpiryDate ? this.documentExpiryDate.toISOString() : <any>undefined;
    data["documentBirthPlace"] = this.documentBirthPlace;
    data["documentNationality"] = this.documentNationality;
    data["documentSex"] = this.documentSex;
    data["documentAddress"] = this.documentAddress;
    data["documentPersonalNumber"] = this.documentPersonalNumber;
    data["documentHeight"] = this.documentHeight;
    data["documentCharType"] = this.documentCharType;
    data["documentCountryCode"] = this.documentCountryCode;
    data["documentResidence"] = this.documentResidence;
    data["documentCardName"] = this.documentCardName;
    data["documentReligion"] = this.documentReligion;
    data["documentCardAdministrative"] = this.documentCardAdministrative;
    data["documentCardPIN"] = this.documentCardPIN;
    data["documentStartDate"] = this.documentStartDate ? this.documentStartDate.toISOString() : <any>undefined;
    data["driverLicenseCategory"] = this.driverLicenseCategory;
    data["driverAlamat"] = this.driverAlamat;
    data["driverTempat"] = this.driverTempat;
    data["driverPekerjaan"] = this.driverPekerjaan;
    data["driverSIM"] = this.driverSIM;
    data["driverBerlaku"] = this.driverBerlaku;
    data["driverProvinceCode"] = this.driverProvinceCode;
    data["driverPlaceRegistration"] = this.driverPlaceRegistration;
    data["driverDateRegistration"] = this.driverDateRegistration ? this.driverDateRegistration.toISOString() : <any>undefined;
    data["driverHeadquarter"] = this.driverHeadquarter;
    data["driverConditions"] = this.driverConditions;
    data["driverClass"] = this.driverClass;
    data["isDisplayDocument"] = this.isDisplayDocument;
    data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>undefined;
    data["country"] = this.country ? this.country.toJSON() : <any>undefined;
    data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IProfileDocument {
  profileId?: number | undefined;
  countryId?: number | undefined;
  documentType?: DocumentType;
  documentNumber?: string | undefined;
  documentSurname?: string | undefined;
  documentName?: string | undefined;
  documentBirthDate?: Date | undefined;
  documentIssuedDate?: Date | undefined;
  documentAuthority?: string | undefined;
  documentExpiryDate?: Date | undefined;
  documentBirthPlace?: string | undefined;
  documentNationality?: string | undefined;
  documentSex?: string | undefined;
  documentAddress?: string | undefined;
  documentPersonalNumber?: string | undefined;
  documentHeight?: string | undefined;
  documentCharType?: string | undefined;
  documentCountryCode?: string | undefined;
  documentResidence?: string | undefined;
  documentCardName?: string | undefined;
  documentReligion?: string | undefined;
  documentCardAdministrative?: string | undefined;
  documentCardPIN?: string | undefined;
  documentStartDate?: Date | undefined;
  driverLicenseCategory?: string | undefined;
  driverAlamat?: string | undefined;
  driverTempat?: string | undefined;
  driverPekerjaan?: string | undefined;
  driverSIM?: string | undefined;
  driverBerlaku?: string | undefined;
  driverProvinceCode?: string | undefined;
  driverPlaceRegistration?: string | undefined;
  driverDateRegistration?: Date | undefined;
  driverHeadquarter?: string | undefined;
  driverConditions?: string | undefined;
  driverClass?: string | undefined;
  isDisplayDocument?: boolean;
  deletedDate?: Date | undefined;
  country?: Country;
  profile?: PersonalProfile;
  id?: number;
}

export class ProfileDocumentPattern implements IProfileDocumentPattern {
  profileId?: number;
  name?: string | undefined;
  description?: string | undefined;
  createDate?: Date;
  deletedDate?: Date | undefined;
  profile?: Profile;
  id?: number;

  constructor(data?: IProfileDocumentPattern) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
      this.deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : <any>undefined;
      this.profile = _data["profile"] ? Profile.fromJS(_data["profile"]) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProfileDocumentPattern {
    data = typeof data === 'object' ? data : {};
    let result = new ProfileDocumentPattern();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["name"] = this.name;
    data["description"] = this.description;
    data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
    data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>undefined;
    data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IProfileDocumentPattern {
  profileId?: number;
  name?: string | undefined;
  description?: string | undefined;
  createDate?: Date;
  deletedDate?: Date | undefined;
  profile?: Profile;
  id?: number;
}

/** Profile document pattern model */
export class ProfileDocumentPatternViewModel implements IProfileDocumentPatternViewModel {
  /** Profile id */
  profileId?: number;
  /** Name */
  name?: string | undefined;
  /** Description */
  description?: string | undefined;

  constructor(data?: IProfileDocumentPatternViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.name = _data["name"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): ProfileDocumentPatternViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ProfileDocumentPatternViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["name"] = this.name;
    data["description"] = this.description;
    return data;
  }
}

/** Profile document pattern model */
export interface IProfileDocumentPatternViewModel {
  /** Profile id */
  profileId?: number;
  /** Name */
  name?: string | undefined;
  /** Description */
  description?: string | undefined;
}

export class ProfileDocumentResult implements IProfileDocumentResult {
  id?: number;
  profileId?: number | undefined;
  countryId?: number | undefined;
  documentType?: DocumentType;
  documentNumber?: string | undefined;
  documentSurname?: string | undefined;
  documentName?: string | undefined;
  documentBirthDate?: Date | undefined;
  documentIssuedDate?: Date | undefined;
  documentAuthority?: string | undefined;
  documentExpiryDate?: Date | undefined;
  documentBirthPlace?: string | undefined;
  documentNationality?: string | undefined;
  documentSex?: string | undefined;
  documentAddress?: string | undefined;
  documentPersonalNumber?: string | undefined;
  documentHeight?: string | undefined;
  documentCharType?: string | undefined;
  documentCountryCode?: string | undefined;
  documentResidence?: string | undefined;
  documentCardName?: string | undefined;
  documentReligion?: string | undefined;
  documentCardAdministrative?: string | undefined;
  documentCardPIN?: string | undefined;
  documentStartDate?: Date | undefined;
  driverLicenseCategory?: string | undefined;
  driverAlamat?: string | undefined;
  driverTempat?: string | undefined;
  driverPekerjaan?: string | undefined;
  driverSIM?: string | undefined;
  driverBerlaku?: string | undefined;
  driverProvinceCode?: string | undefined;
  driverPlaceRegistration?: string | undefined;
  driverDateRegistration?: Date | undefined;
  driverHeadquarter?: string | undefined;
  driverConditions?: string | undefined;
  driverClass?: string | undefined;
  isDisplayDocument?: boolean;

  constructor(data?: IProfileDocumentResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.profileId = _data["profileId"];
      this.countryId = _data["countryId"];
      this.documentType = _data["documentType"];
      this.documentNumber = _data["documentNumber"];
      this.documentSurname = _data["documentSurname"];
      this.documentName = _data["documentName"];
      this.documentBirthDate = _data["documentBirthDate"] ? new Date(_data["documentBirthDate"].toString()) : <any>undefined;
      this.documentIssuedDate = _data["documentIssuedDate"] ? new Date(_data["documentIssuedDate"].toString()) : <any>undefined;
      this.documentAuthority = _data["documentAuthority"];
      this.documentExpiryDate = _data["documentExpiryDate"] ? new Date(_data["documentExpiryDate"].toString()) : <any>undefined;
      this.documentBirthPlace = _data["documentBirthPlace"];
      this.documentNationality = _data["documentNationality"];
      this.documentSex = _data["documentSex"];
      this.documentAddress = _data["documentAddress"];
      this.documentPersonalNumber = _data["documentPersonalNumber"];
      this.documentHeight = _data["documentHeight"];
      this.documentCharType = _data["documentCharType"];
      this.documentCountryCode = _data["documentCountryCode"];
      this.documentResidence = _data["documentResidence"];
      this.documentCardName = _data["documentCardName"];
      this.documentReligion = _data["documentReligion"];
      this.documentCardAdministrative = _data["documentCardAdministrative"];
      this.documentCardPIN = _data["documentCardPIN"];
      this.documentStartDate = _data["documentStartDate"] ? new Date(_data["documentStartDate"].toString()) : <any>undefined;
      this.driverLicenseCategory = _data["driverLicenseCategory"];
      this.driverAlamat = _data["driverAlamat"];
      this.driverTempat = _data["driverTempat"];
      this.driverPekerjaan = _data["driverPekerjaan"];
      this.driverSIM = _data["driverSIM"];
      this.driverBerlaku = _data["driverBerlaku"];
      this.driverProvinceCode = _data["driverProvinceCode"];
      this.driverPlaceRegistration = _data["driverPlaceRegistration"];
      this.driverDateRegistration = _data["driverDateRegistration"] ? new Date(_data["driverDateRegistration"].toString()) : <any>undefined;
      this.driverHeadquarter = _data["driverHeadquarter"];
      this.driverConditions = _data["driverConditions"];
      this.driverClass = _data["driverClass"];
      this.isDisplayDocument = _data["isDisplayDocument"];
    }
  }

  static fromJS(data: any): ProfileDocumentResult {
    data = typeof data === 'object' ? data : {};
    let result = new ProfileDocumentResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["profileId"] = this.profileId;
    data["countryId"] = this.countryId;
    data["documentType"] = this.documentType;
    data["documentNumber"] = this.documentNumber;
    data["documentSurname"] = this.documentSurname;
    data["documentName"] = this.documentName;
    data["documentBirthDate"] = this.documentBirthDate ? this.documentBirthDate.toISOString() : <any>undefined;
    data["documentIssuedDate"] = this.documentIssuedDate ? this.documentIssuedDate.toISOString() : <any>undefined;
    data["documentAuthority"] = this.documentAuthority;
    data["documentExpiryDate"] = this.documentExpiryDate ? this.documentExpiryDate.toISOString() : <any>undefined;
    data["documentBirthPlace"] = this.documentBirthPlace;
    data["documentNationality"] = this.documentNationality;
    data["documentSex"] = this.documentSex;
    data["documentAddress"] = this.documentAddress;
    data["documentPersonalNumber"] = this.documentPersonalNumber;
    data["documentHeight"] = this.documentHeight;
    data["documentCharType"] = this.documentCharType;
    data["documentCountryCode"] = this.documentCountryCode;
    data["documentResidence"] = this.documentResidence;
    data["documentCardName"] = this.documentCardName;
    data["documentReligion"] = this.documentReligion;
    data["documentCardAdministrative"] = this.documentCardAdministrative;
    data["documentCardPIN"] = this.documentCardPIN;
    data["documentStartDate"] = this.documentStartDate ? this.documentStartDate.toISOString() : <any>undefined;
    data["driverLicenseCategory"] = this.driverLicenseCategory;
    data["driverAlamat"] = this.driverAlamat;
    data["driverTempat"] = this.driverTempat;
    data["driverPekerjaan"] = this.driverPekerjaan;
    data["driverSIM"] = this.driverSIM;
    data["driverBerlaku"] = this.driverBerlaku;
    data["driverProvinceCode"] = this.driverProvinceCode;
    data["driverPlaceRegistration"] = this.driverPlaceRegistration;
    data["driverDateRegistration"] = this.driverDateRegistration ? this.driverDateRegistration.toISOString() : <any>undefined;
    data["driverHeadquarter"] = this.driverHeadquarter;
    data["driverConditions"] = this.driverConditions;
    data["driverClass"] = this.driverClass;
    data["isDisplayDocument"] = this.isDisplayDocument;
    return data;
  }
}

export interface IProfileDocumentResult {
  id?: number;
  profileId?: number | undefined;
  countryId?: number | undefined;
  documentType?: DocumentType;
  documentNumber?: string | undefined;
  documentSurname?: string | undefined;
  documentName?: string | undefined;
  documentBirthDate?: Date | undefined;
  documentIssuedDate?: Date | undefined;
  documentAuthority?: string | undefined;
  documentExpiryDate?: Date | undefined;
  documentBirthPlace?: string | undefined;
  documentNationality?: string | undefined;
  documentSex?: string | undefined;
  documentAddress?: string | undefined;
  documentPersonalNumber?: string | undefined;
  documentHeight?: string | undefined;
  documentCharType?: string | undefined;
  documentCountryCode?: string | undefined;
  documentResidence?: string | undefined;
  documentCardName?: string | undefined;
  documentReligion?: string | undefined;
  documentCardAdministrative?: string | undefined;
  documentCardPIN?: string | undefined;
  documentStartDate?: Date | undefined;
  driverLicenseCategory?: string | undefined;
  driverAlamat?: string | undefined;
  driverTempat?: string | undefined;
  driverPekerjaan?: string | undefined;
  driverSIM?: string | undefined;
  driverBerlaku?: string | undefined;
  driverProvinceCode?: string | undefined;
  driverPlaceRegistration?: string | undefined;
  driverDateRegistration?: Date | undefined;
  driverHeadquarter?: string | undefined;
  driverConditions?: string | undefined;
  driverClass?: string | undefined;
  isDisplayDocument?: boolean;
}

export class ProfileDocumentViewModel implements IProfileDocumentViewModel {
  id?: number | undefined;
  profileId?: number | undefined;
  countryId?: number | undefined;
  documentType?: DocumentType;
  documentNumber?: string | undefined;
  documentSurname?: string | undefined;
  documentName?: string | undefined;
  documentBirthDate?: Date | undefined;
  documentIssuedDate?: Date | undefined;
  documentAuthority?: string | undefined;
  documentExpiryDate?: Date | undefined;
  documentBirthPlace?: string | undefined;
  documentNationality?: string | undefined;
  documentSex?: string | undefined;
  documentAddress?: string | undefined;
  documentPersonalNumber?: string | undefined;
  documentHeight?: string | undefined;
  documentCharType?: string | undefined;
  documentCountryCode?: string | undefined;
  documentResidence?: string | undefined;
  documentCardName?: string | undefined;
  documentReligion?: string | undefined;
  documentCardAdministrative?: string | undefined;
  documentCardPIN?: string | undefined;
  documentStartDate?: Date | undefined;
  driverLicenseCategory?: string | undefined;
  driverAlamat?: string | undefined;
  driverTempat?: string | undefined;
  driverPekerjaan?: string | undefined;
  driverSIM?: string | undefined;
  driverBerlaku?: string | undefined;
  driverProvinceCode?: string | undefined;
  driverPlaceRegistration?: string | undefined;
  driverDateRegistration?: Date | undefined;
  driverHeadquarter?: string | undefined;
  driverConditions?: string | undefined;
  driverClass?: string | undefined;
  isDisplayDocument?: boolean;

  constructor(data?: IProfileDocumentViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.profileId = _data["profileId"];
      this.countryId = _data["countryId"];
      this.documentType = _data["documentType"];
      this.documentNumber = _data["documentNumber"];
      this.documentSurname = _data["documentSurname"];
      this.documentName = _data["documentName"];
      this.documentBirthDate = _data["documentBirthDate"] ? new Date(_data["documentBirthDate"].toString()) : <any>undefined;
      this.documentIssuedDate = _data["documentIssuedDate"] ? new Date(_data["documentIssuedDate"].toString()) : <any>undefined;
      this.documentAuthority = _data["documentAuthority"];
      this.documentExpiryDate = _data["documentExpiryDate"] ? new Date(_data["documentExpiryDate"].toString()) : <any>undefined;
      this.documentBirthPlace = _data["documentBirthPlace"];
      this.documentNationality = _data["documentNationality"];
      this.documentSex = _data["documentSex"];
      this.documentAddress = _data["documentAddress"];
      this.documentPersonalNumber = _data["documentPersonalNumber"];
      this.documentHeight = _data["documentHeight"];
      this.documentCharType = _data["documentCharType"];
      this.documentCountryCode = _data["documentCountryCode"];
      this.documentResidence = _data["documentResidence"];
      this.documentCardName = _data["documentCardName"];
      this.documentReligion = _data["documentReligion"];
      this.documentCardAdministrative = _data["documentCardAdministrative"];
      this.documentCardPIN = _data["documentCardPIN"];
      this.documentStartDate = _data["documentStartDate"] ? new Date(_data["documentStartDate"].toString()) : <any>undefined;
      this.driverLicenseCategory = _data["driverLicenseCategory"];
      this.driverAlamat = _data["driverAlamat"];
      this.driverTempat = _data["driverTempat"];
      this.driverPekerjaan = _data["driverPekerjaan"];
      this.driverSIM = _data["driverSIM"];
      this.driverBerlaku = _data["driverBerlaku"];
      this.driverProvinceCode = _data["driverProvinceCode"];
      this.driverPlaceRegistration = _data["driverPlaceRegistration"];
      this.driverDateRegistration = _data["driverDateRegistration"] ? new Date(_data["driverDateRegistration"].toString()) : <any>undefined;
      this.driverHeadquarter = _data["driverHeadquarter"];
      this.driverConditions = _data["driverConditions"];
      this.driverClass = _data["driverClass"];
      this.isDisplayDocument = _data["isDisplayDocument"];
    }
  }

  static fromJS(data: any): ProfileDocumentViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ProfileDocumentViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["profileId"] = this.profileId;
    data["countryId"] = this.countryId;
    data["documentType"] = this.documentType;
    data["documentNumber"] = this.documentNumber;
    data["documentSurname"] = this.documentSurname;
    data["documentName"] = this.documentName;
    data["documentBirthDate"] = this.documentBirthDate ? this.documentBirthDate.toISOString() : <any>undefined;
    data["documentIssuedDate"] = this.documentIssuedDate ? this.documentIssuedDate.toISOString() : <any>undefined;
    data["documentAuthority"] = this.documentAuthority;
    data["documentExpiryDate"] = this.documentExpiryDate ? this.documentExpiryDate.toISOString() : <any>undefined;
    data["documentBirthPlace"] = this.documentBirthPlace;
    data["documentNationality"] = this.documentNationality;
    data["documentSex"] = this.documentSex;
    data["documentAddress"] = this.documentAddress;
    data["documentPersonalNumber"] = this.documentPersonalNumber;
    data["documentHeight"] = this.documentHeight;
    data["documentCharType"] = this.documentCharType;
    data["documentCountryCode"] = this.documentCountryCode;
    data["documentResidence"] = this.documentResidence;
    data["documentCardName"] = this.documentCardName;
    data["documentReligion"] = this.documentReligion;
    data["documentCardAdministrative"] = this.documentCardAdministrative;
    data["documentCardPIN"] = this.documentCardPIN;
    data["documentStartDate"] = this.documentStartDate ? this.documentStartDate.toISOString() : <any>undefined;
    data["driverLicenseCategory"] = this.driverLicenseCategory;
    data["driverAlamat"] = this.driverAlamat;
    data["driverTempat"] = this.driverTempat;
    data["driverPekerjaan"] = this.driverPekerjaan;
    data["driverSIM"] = this.driverSIM;
    data["driverBerlaku"] = this.driverBerlaku;
    data["driverProvinceCode"] = this.driverProvinceCode;
    data["driverPlaceRegistration"] = this.driverPlaceRegistration;
    data["driverDateRegistration"] = this.driverDateRegistration ? this.driverDateRegistration.toISOString() : <any>undefined;
    data["driverHeadquarter"] = this.driverHeadquarter;
    data["driverConditions"] = this.driverConditions;
    data["driverClass"] = this.driverClass;
    data["isDisplayDocument"] = this.isDisplayDocument;
    return data;
  }
}

export interface IProfileDocumentViewModel {
  id?: number | undefined;
  profileId?: number | undefined;
  countryId?: number | undefined;
  documentType?: DocumentType;
  documentNumber?: string | undefined;
  documentSurname?: string | undefined;
  documentName?: string | undefined;
  documentBirthDate?: Date | undefined;
  documentIssuedDate?: Date | undefined;
  documentAuthority?: string | undefined;
  documentExpiryDate?: Date | undefined;
  documentBirthPlace?: string | undefined;
  documentNationality?: string | undefined;
  documentSex?: string | undefined;
  documentAddress?: string | undefined;
  documentPersonalNumber?: string | undefined;
  documentHeight?: string | undefined;
  documentCharType?: string | undefined;
  documentCountryCode?: string | undefined;
  documentResidence?: string | undefined;
  documentCardName?: string | undefined;
  documentReligion?: string | undefined;
  documentCardAdministrative?: string | undefined;
  documentCardPIN?: string | undefined;
  documentStartDate?: Date | undefined;
  driverLicenseCategory?: string | undefined;
  driverAlamat?: string | undefined;
  driverTempat?: string | undefined;
  driverPekerjaan?: string | undefined;
  driverSIM?: string | undefined;
  driverBerlaku?: string | undefined;
  driverProvinceCode?: string | undefined;
  driverPlaceRegistration?: string | undefined;
  driverDateRegistration?: Date | undefined;
  driverHeadquarter?: string | undefined;
  driverConditions?: string | undefined;
  driverClass?: string | undefined;
  isDisplayDocument?: boolean;
}

export class ProfileMultipleQueryResult implements IProfileMultipleQueryResult {
  count?: number;
  data?: Profile[] | undefined;

  constructor(data?: IProfileMultipleQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data["count"];
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(Profile.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ProfileMultipleQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new ProfileMultipleQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["count"] = this.count;
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data)
        data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IProfileMultipleQueryResult {
  count?: number;
  data?: Profile[] | undefined;
}

export class ProfileUnconfirmedEmail implements IProfileUnconfirmedEmail {
  profileId?: number;
  newEmail?: string | undefined;
  confirmationCode?: string | undefined;
  expiredCodeDate?: Date;
  isNewProfile?: boolean;
  profile?: Profile;
  id?: number;

  constructor(data?: IProfileUnconfirmedEmail) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.newEmail = _data["newEmail"];
      this.confirmationCode = _data["confirmationCode"];
      this.expiredCodeDate = _data["expiredCodeDate"] ? new Date(_data["expiredCodeDate"].toString()) : <any>undefined;
      this.isNewProfile = _data["isNewProfile"];
      this.profile = _data["profile"] ? Profile.fromJS(_data["profile"]) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProfileUnconfirmedEmail {
    data = typeof data === 'object' ? data : {};
    let result = new ProfileUnconfirmedEmail();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["newEmail"] = this.newEmail;
    data["confirmationCode"] = this.confirmationCode;
    data["expiredCodeDate"] = this.expiredCodeDate ? this.expiredCodeDate.toISOString() : <any>undefined;
    data["isNewProfile"] = this.isNewProfile;
    data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IProfileUnconfirmedEmail {
  profileId?: number;
  newEmail?: string | undefined;
  confirmationCode?: string | undefined;
  expiredCodeDate?: Date;
  isNewProfile?: boolean;
  profile?: Profile;
  id?: number;
}

export class ProfilesByTelegramResult implements IProfilesByTelegramResult {
  details?: ProfilesTelegram[] | undefined;

  constructor(data?: IProfilesByTelegramResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["details"])) {
        this.details = [] as any;
        for (let item of _data["details"])
          this.details!.push(ProfilesTelegram.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ProfilesByTelegramResult {
    data = typeof data === 'object' ? data : {};
    let result = new ProfilesByTelegramResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.details)) {
      data["details"] = [];
      for (let item of this.details)
        data["details"].push(item.toJSON());
    }
    return data;
  }
}

export interface IProfilesByTelegramResult {
  details?: ProfilesTelegram[] | undefined;
}

export class ProfilesContractor implements IProfilesContractor {
  profileId?: number;
  contractorProfileId?: number;
  createDate?: Date;
  deleteDate?: Date | undefined;
  profile?: Profile;
  contractorProfile?: Profile;
  id?: number;

  constructor(data?: IProfilesContractor) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.contractorProfileId = _data["contractorProfileId"];
      this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
      this.deleteDate = _data["deleteDate"] ? new Date(_data["deleteDate"].toString()) : <any>undefined;
      this.profile = _data["profile"] ? Profile.fromJS(_data["profile"]) : <any>undefined;
      this.contractorProfile = _data["contractorProfile"] ? Profile.fromJS(_data["contractorProfile"]) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProfilesContractor {
    data = typeof data === 'object' ? data : {};
    let result = new ProfilesContractor();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["contractorProfileId"] = this.contractorProfileId;
    data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
    data["deleteDate"] = this.deleteDate ? this.deleteDate.toISOString() : <any>undefined;
    data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
    data["contractorProfile"] = this.contractorProfile ? this.contractorProfile.toJSON() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IProfilesContractor {
  profileId?: number;
  contractorProfileId?: number;
  createDate?: Date;
  deleteDate?: Date | undefined;
  profile?: Profile;
  contractorProfile?: Profile;
  id?: number;
}

export class ProfilesOracle implements IProfilesOracle {
  profileId?: number;
  oracleProfileId?: number;
  createDate?: Date;
  deleteDate?: Date | undefined;
  profile?: Profile;
  oracleProfile?: Profile;
  id?: number;

  constructor(data?: IProfilesOracle) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.oracleProfileId = _data["oracleProfileId"];
      this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
      this.deleteDate = _data["deleteDate"] ? new Date(_data["deleteDate"].toString()) : <any>undefined;
      this.profile = _data["profile"] ? Profile.fromJS(_data["profile"]) : <any>undefined;
      this.oracleProfile = _data["oracleProfile"] ? Profile.fromJS(_data["oracleProfile"]) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProfilesOracle {
    data = typeof data === 'object' ? data : {};
    let result = new ProfilesOracle();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["oracleProfileId"] = this.oracleProfileId;
    data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
    data["deleteDate"] = this.deleteDate ? this.deleteDate.toISOString() : <any>undefined;
    data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
    data["oracleProfile"] = this.oracleProfile ? this.oracleProfile.toJSON() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IProfilesOracle {
  profileId?: number;
  oracleProfileId?: number;
  createDate?: Date;
  deleteDate?: Date | undefined;
  profile?: Profile;
  oracleProfile?: Profile;
  id?: number;
}

export class ProfilesTelegram implements IProfilesTelegram {
  profileId?: number;
  telegramId?: string | undefined;

  constructor(data?: IProfilesTelegram) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.telegramId = _data["telegramId"];
    }
  }

  static fromJS(data: any): ProfilesTelegram {
    data = typeof data === 'object' ? data : {};
    let result = new ProfilesTelegram();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["telegramId"] = this.telegramId;
    return data;
  }
}

export interface IProfilesTelegram {
  profileId?: number;
  telegramId?: string | undefined;
}

export class RenewJwtTokenRequest implements IRenewJwtTokenRequest {
  token?: string | undefined;

  constructor(data?: IRenewJwtTokenRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data["token"];
    }
  }

  static fromJS(data: any): RenewJwtTokenRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RenewJwtTokenRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["token"] = this.token;
    return data;
  }
}

export interface IRenewJwtTokenRequest {
  token?: string | undefined;
}

export class SendConfirmationCodeViewModel implements ISendConfirmationCodeViewModel {
  email?: string | undefined;

  constructor(data?: ISendConfirmationCodeViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
    }
  }

  static fromJS(data: any): SendConfirmationCodeViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new SendConfirmationCodeViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["email"] = this.email;
    return data;
  }
}

export interface ISendConfirmationCodeViewModel {
  email?: string | undefined;
}

export class SetOrganizationAgentRequestTypeViewModel implements ISetOrganizationAgentRequestTypeViewModel {
  requestType?: OrganizationRequestType;
  organizationProfileId?: number;
  agentProfileId?: number;

  constructor(data?: ISetOrganizationAgentRequestTypeViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.requestType = _data["requestType"];
      this.organizationProfileId = _data["organizationProfileId"];
      this.agentProfileId = _data["agentProfileId"];
    }
  }

  static fromJS(data: any): SetOrganizationAgentRequestTypeViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new SetOrganizationAgentRequestTypeViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["requestType"] = this.requestType;
    data["organizationProfileId"] = this.organizationProfileId;
    data["agentProfileId"] = this.agentProfileId;
    return data;
  }
}

export interface ISetOrganizationAgentRequestTypeViewModel {
  requestType?: OrganizationRequestType;
  organizationProfileId?: number;
  agentProfileId?: number;
}

export class SetPasswordRequest implements ISetPasswordRequest {
  newPassword?: string | undefined;
  confirmNewPassword?: string | undefined;

  constructor(data?: ISetPasswordRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.newPassword = _data["newPassword"];
      this.confirmNewPassword = _data["confirmNewPassword"];
    }
  }

  static fromJS(data: any): SetPasswordRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SetPasswordRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["newPassword"] = this.newPassword;
    data["confirmNewPassword"] = this.confirmNewPassword;
    return data;
  }
}

export interface ISetPasswordRequest {
  newPassword?: string | undefined;
  confirmNewPassword?: string | undefined;
}

export class SignInRequest implements ISignInRequest {
  email?: string | undefined;
  password?: string | undefined;

  constructor(data?: ISignInRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
      this.password = _data["password"];
    }
  }

  static fromJS(data: any): SignInRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SignInRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["email"] = this.email;
    data["password"] = this.password;
    return data;
  }
}

export interface ISignInRequest {
  email?: string | undefined;
  password?: string | undefined;
}

export class SignInResponse implements ISignInResponse {
  twoFaRequired?: boolean;
  twoFaToken?: string | undefined;
  latestTwoFaRemindDate?: Date | undefined;
  access_token?: string | undefined;
  issued?: Date | undefined;
  expires_in?: number | undefined;
  refresh_token?: string | undefined;

  constructor(data?: ISignInResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.twoFaRequired = _data["twoFaRequired"];
      this.twoFaToken = _data["twoFaToken"];
      this.latestTwoFaRemindDate = _data["latestTwoFaRemindDate"] ? new Date(_data["latestTwoFaRemindDate"].toString()) : <any>undefined;
      this.access_token = _data["access_token"];
      this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : <any>undefined;
      this.expires_in = _data["expires_in"];
      this.refresh_token = _data["refresh_token"];
    }
  }

  static fromJS(data: any): SignInResponse {
    data = typeof data === 'object' ? data : {};
    let result = new SignInResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["twoFaRequired"] = this.twoFaRequired;
    data["twoFaToken"] = this.twoFaToken;
    data["latestTwoFaRemindDate"] = this.latestTwoFaRemindDate ? this.latestTwoFaRemindDate.toISOString() : <any>undefined;
    data["access_token"] = this.access_token;
    data["issued"] = this.issued ? this.issued.toISOString() : <any>undefined;
    data["expires_in"] = this.expires_in;
    data["refresh_token"] = this.refresh_token;
    return data;
  }
}

export interface ISignInResponse {
  twoFaRequired?: boolean;
  twoFaToken?: string | undefined;
  latestTwoFaRemindDate?: Date | undefined;
  access_token?: string | undefined;
  issued?: Date | undefined;
  expires_in?: number | undefined;
  refresh_token?: string | undefined;
}

/** Query model 'Subscribe to profile'. */
export class SubscribeViewModel implements ISubscribeViewModel {
  readonly profileId?: number;
  readonly subscriptionProfileId?: number;

  constructor(data?: ISubscribeViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).profileId = _data["profileId"];
      (<any>this).subscriptionProfileId = _data["subscriptionProfileId"];
    }
  }

  static fromJS(data: any): SubscribeViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new SubscribeViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["subscriptionProfileId"] = this.subscriptionProfileId;
    return data;
  }
}

/** Query model 'Subscribe to profile'. */
export interface ISubscribeViewModel {
  profileId?: number;
  subscriptionProfileId?: number;
}

export class Subscription implements ISubscription {
  profileId?: number;
  subscriptionProfileId?: number;
  subscribeDateTime?: Date | undefined;
  profile?: Profile;
  subscriptionProfile?: Profile;
  id?: number;

  constructor(data?: ISubscription) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.subscriptionProfileId = _data["subscriptionProfileId"];
      this.subscribeDateTime = _data["subscribeDateTime"] ? new Date(_data["subscribeDateTime"].toString()) : <any>undefined;
      this.profile = _data["profile"] ? Profile.fromJS(_data["profile"]) : <any>undefined;
      this.subscriptionProfile = _data["subscriptionProfile"] ? Profile.fromJS(_data["subscriptionProfile"]) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Subscription {
    data = typeof data === 'object' ? data : {};
    let result = new Subscription();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["subscriptionProfileId"] = this.subscriptionProfileId;
    data["subscribeDateTime"] = this.subscribeDateTime ? this.subscribeDateTime.toISOString() : <any>undefined;
    data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
    data["subscriptionProfile"] = this.subscriptionProfile ? this.subscriptionProfile.toJSON() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface ISubscription {
  profileId?: number;
  subscriptionProfileId?: number;
  subscribeDateTime?: Date | undefined;
  profile?: Profile;
  subscriptionProfile?: Profile;
  id?: number;
}

export class ToggleOracleRequest implements IToggleOracleRequest {
  profileId?: number;
  value?: boolean;

  constructor(data?: IToggleOracleRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): ToggleOracleRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ToggleOracleRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["value"] = this.value;
    return data;
  }
}

export interface IToggleOracleRequest {
  profileId?: number;
  value?: boolean;
}

export class TwoFaKeyAndQrCodeResponse implements ITwoFaKeyAndQrCodeResponse {
  formattedAuthenticatorKey?: string | undefined;
  qrCode?: string | undefined;

  constructor(data?: ITwoFaKeyAndQrCodeResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.formattedAuthenticatorKey = _data["formattedAuthenticatorKey"];
      this.qrCode = _data["qrCode"];
    }
  }

  static fromJS(data: any): TwoFaKeyAndQrCodeResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TwoFaKeyAndQrCodeResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["formattedAuthenticatorKey"] = this.formattedAuthenticatorKey;
    data["qrCode"] = this.qrCode;
    return data;
  }
}

export interface ITwoFaKeyAndQrCodeResponse {
  formattedAuthenticatorKey?: string | undefined;
  qrCode?: string | undefined;
}

export class TwoFactorConfirmationRequest implements ITwoFactorConfirmationRequest {
  token?: string | undefined;
  code?: string | undefined;

  constructor(data?: ITwoFactorConfirmationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data["token"];
      this.code = _data["code"];
    }
  }

  static fromJS(data: any): TwoFactorConfirmationRequest {
    data = typeof data === 'object' ? data : {};
    let result = new TwoFactorConfirmationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["token"] = this.token;
    data["code"] = this.code;
    return data;
  }
}

export interface ITwoFactorConfirmationRequest {
  token?: string | undefined;
  code?: string | undefined;
}

export class User implements IUser {
  firstName?: string | undefined;
  lastName?: string | undefined;
  salt?: string | undefined;
  accountType?: AccountType;
  googleId?: string | undefined;
  facebookId?: string | undefined;
  linkedinId?: string | undefined;
  telegramId?: string | undefined;
  passwordChangeDate?: Date | undefined;
  latestTwoFaRemindDate?: Date | undefined;
  profiles?: Profile[] | undefined;
  userUnconfirmedEmails?: UserUnconfirmedEmail[] | undefined;
  id?: string;
  userName?: string | undefined;
  normalizedUserName?: string | undefined;
  email?: string | undefined;
  normalizedEmail?: string | undefined;
  emailConfirmed?: boolean;
  passwordHash?: string | undefined;
  securityStamp?: string | undefined;
  concurrencyStamp?: string | undefined;
  phoneNumber?: string | undefined;
  phoneNumberConfirmed?: boolean;
  twoFactorEnabled?: boolean;
  lockoutEnd?: Date | undefined;
  lockoutEnabled?: boolean;
  accessFailedCount?: number;

  constructor(data?: IUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.salt = _data["salt"];
      this.accountType = _data["accountType"];
      this.googleId = _data["googleId"];
      this.facebookId = _data["facebookId"];
      this.linkedinId = _data["linkedinId"];
      this.telegramId = _data["telegramId"];
      this.passwordChangeDate = _data["passwordChangeDate"] ? new Date(_data["passwordChangeDate"].toString()) : <any>undefined;
      this.latestTwoFaRemindDate = _data["latestTwoFaRemindDate"] ? new Date(_data["latestTwoFaRemindDate"].toString()) : <any>undefined;
      if (Array.isArray(_data["profiles"])) {
        this.profiles = [] as any;
        for (let item of _data["profiles"])
          this.profiles!.push(Profile.fromJS(item));
      }
      if (Array.isArray(_data["userUnconfirmedEmails"])) {
        this.userUnconfirmedEmails = [] as any;
        for (let item of _data["userUnconfirmedEmails"])
          this.userUnconfirmedEmails!.push(UserUnconfirmedEmail.fromJS(item));
      }
      this.id = _data["id"];
      this.userName = _data["userName"];
      this.normalizedUserName = _data["normalizedUserName"];
      this.email = _data["email"];
      this.normalizedEmail = _data["normalizedEmail"];
      this.emailConfirmed = _data["emailConfirmed"];
      this.passwordHash = _data["passwordHash"];
      this.securityStamp = _data["securityStamp"];
      this.concurrencyStamp = _data["concurrencyStamp"];
      this.phoneNumber = _data["phoneNumber"];
      this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
      this.twoFactorEnabled = _data["twoFactorEnabled"];
      this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
      this.lockoutEnabled = _data["lockoutEnabled"];
      this.accessFailedCount = _data["accessFailedCount"];
    }
  }

  static fromJS(data: any): User {
    data = typeof data === 'object' ? data : {};
    let result = new User();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["salt"] = this.salt;
    data["accountType"] = this.accountType;
    data["googleId"] = this.googleId;
    data["facebookId"] = this.facebookId;
    data["linkedinId"] = this.linkedinId;
    data["telegramId"] = this.telegramId;
    data["passwordChangeDate"] = this.passwordChangeDate ? this.passwordChangeDate.toISOString() : <any>undefined;
    data["latestTwoFaRemindDate"] = this.latestTwoFaRemindDate ? this.latestTwoFaRemindDate.toISOString() : <any>undefined;
    if (Array.isArray(this.profiles)) {
      data["profiles"] = [];
      for (let item of this.profiles)
        data["profiles"].push(item.toJSON());
    }
    if (Array.isArray(this.userUnconfirmedEmails)) {
      data["userUnconfirmedEmails"] = [];
      for (let item of this.userUnconfirmedEmails)
        data["userUnconfirmedEmails"].push(item.toJSON());
    }
    data["id"] = this.id;
    data["userName"] = this.userName;
    data["normalizedUserName"] = this.normalizedUserName;
    data["email"] = this.email;
    data["normalizedEmail"] = this.normalizedEmail;
    data["emailConfirmed"] = this.emailConfirmed;
    data["passwordHash"] = this.passwordHash;
    data["securityStamp"] = this.securityStamp;
    data["concurrencyStamp"] = this.concurrencyStamp;
    data["phoneNumber"] = this.phoneNumber;
    data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
    data["twoFactorEnabled"] = this.twoFactorEnabled;
    data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
    data["lockoutEnabled"] = this.lockoutEnabled;
    data["accessFailedCount"] = this.accessFailedCount;
    return data;
  }
}

export interface IUser {
  firstName?: string | undefined;
  lastName?: string | undefined;
  salt?: string | undefined;
  accountType?: AccountType;
  googleId?: string | undefined;
  facebookId?: string | undefined;
  linkedinId?: string | undefined;
  telegramId?: string | undefined;
  passwordChangeDate?: Date | undefined;
  latestTwoFaRemindDate?: Date | undefined;
  profiles?: Profile[] | undefined;
  userUnconfirmedEmails?: UserUnconfirmedEmail[] | undefined;
  id?: string;
  userName?: string | undefined;
  normalizedUserName?: string | undefined;
  email?: string | undefined;
  normalizedEmail?: string | undefined;
  emailConfirmed?: boolean;
  passwordHash?: string | undefined;
  securityStamp?: string | undefined;
  concurrencyStamp?: string | undefined;
  phoneNumber?: string | undefined;
  phoneNumberConfirmed?: boolean;
  twoFactorEnabled?: boolean;
  lockoutEnd?: Date | undefined;
  lockoutEnabled?: boolean;
  accessFailedCount?: number;
}

export class UserResponse implements IUserResponse {
  id?: string;
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  accountType?: AccountType;
  passwordChangeDate?: Date | undefined;
  is2FaEnabled?: boolean;
  isExternalUser?: boolean;

  constructor(data?: IUserResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.email = _data["email"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.accountType = _data["accountType"];
      this.passwordChangeDate = _data["passwordChangeDate"] ? new Date(_data["passwordChangeDate"].toString()) : <any>undefined;
      this.is2FaEnabled = _data["is2FaEnabled"];
      this.isExternalUser = _data["isExternalUser"];
    }
  }

  static fromJS(data: any): UserResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UserResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["email"] = this.email;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["accountType"] = this.accountType;
    data["passwordChangeDate"] = this.passwordChangeDate ? this.passwordChangeDate.toISOString() : <any>undefined;
    data["is2FaEnabled"] = this.is2FaEnabled;
    data["isExternalUser"] = this.isExternalUser;
    return data;
  }
}

export interface IUserResponse {
  id?: string;
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  accountType?: AccountType;
  passwordChangeDate?: Date | undefined;
  is2FaEnabled?: boolean;
  isExternalUser?: boolean;
}

export class UserUnconfirmedEmail implements IUserUnconfirmedEmail {
  userId?: string;
  newEmail?: string | undefined;
  confirmationCode?: string | undefined;
  expiredCodeDate?: Date;
  user?: User;
  id?: number;

  constructor(data?: IUserUnconfirmedEmail) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.newEmail = _data["newEmail"];
      this.confirmationCode = _data["confirmationCode"];
      this.expiredCodeDate = _data["expiredCodeDate"] ? new Date(_data["expiredCodeDate"].toString()) : <any>undefined;
      this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): UserUnconfirmedEmail {
    data = typeof data === 'object' ? data : {};
    let result = new UserUnconfirmedEmail();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userId"] = this.userId;
    data["newEmail"] = this.newEmail;
    data["confirmationCode"] = this.confirmationCode;
    data["expiredCodeDate"] = this.expiredCodeDate ? this.expiredCodeDate.toISOString() : <any>undefined;
    data["user"] = this.user ? this.user.toJSON() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IUserUnconfirmedEmail {
  userId?: string;
  newEmail?: string | undefined;
  confirmationCode?: string | undefined;
  expiredCodeDate?: Date;
  user?: User;
  id?: number;
}

export class VerifyProfileRequest implements IVerifyProfileRequest {
  profileId?: number;
  fingerprint?: string | undefined;

  constructor(data?: IVerifyProfileRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.fingerprint = _data["fingerprint"];
    }
  }

  static fromJS(data: any): VerifyProfileRequest {
    data = typeof data === 'object' ? data : {};
    let result = new VerifyProfileRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["fingerprint"] = this.fingerprint;
    return data;
  }
}

export interface IVerifyProfileRequest {
  profileId?: number;
  fingerprint?: string | undefined;
}

export class Body implements IBody {
  code?: string;
  id_token?: string;
  state?: string;
  error?: string;
  user?: string;

  [key: string]: any;

  constructor(data?: IBody) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.code = _data["code"];
      this.id_token = _data["id_token"];
      this.state = _data["state"];
      this.error = _data["error"];
      this.user = _data["user"];
    }
  }

  static fromJS(data: any): Body {
    data = typeof data === 'object' ? data : {};
    let result = new Body();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["code"] = this.code;
    data["id_token"] = this.id_token;
    data["state"] = this.state;
    data["error"] = this.error;
    data["user"] = this.user;
    return data;
  }
}

export interface IBody {
  code?: string;
  id_token?: string;
  state?: string;
  error?: string;
  user?: string;

  [key: string]: any;
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return _observableThrow(result);
  else
    return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
